// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,json_types=true"
// @generated from file codes/v3/codes.proto (package codes.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { VersionIncrement, VersionIncrementJson } from "../../asset/v1/asset_pb";
import { file_asset_v1_asset } from "../../asset/v1/asset_pb";
import type { DestinationType, DestinationTypeJson, GS1DigitalLinkData, GS1DigitalLinkDataJson } from "./destination_pb";
import { file_codes_v3_destination } from "./destination_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import { file_common_v1_events } from "../../common/v1/events_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { FieldMask, FieldMaskJson, StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { MappedValue, MappedValueJson } from "../../workflows/v1/workflows_pb";
import { file_workflows_v1_workflows } from "../../workflows/v1/workflows_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file codes/v3/codes.proto.
 */
export const file_codes_v3_codes: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChRjb2Rlcy92My9jb2Rlcy5wcm90bxIIY29kZXMudjMidgoKQ29kZURlc2lnbhIKCgJpZBgBIAEoCRIPCgd2ZXJzaW9uGAQgASgJEicKBmNvbmZpZxgCIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3QSIgoEdHlwZRgDIAEoDjIULmNvZGVzLnYzLkRlc2lnblR5cGUijQEKC0Rlc3RpbmF0aW9uEg0KBXZhbHVlGAEgASgJEioKBHJ1bGUYAiABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0SACIAQESJwoEdHlwZRgDIAEoDjIZLmNvZGVzLnYzLkRlc3RpbmF0aW9uVHlwZRIRCglpc19hY3RpdmUYBSABKAhCBwoFX3J1bGUiRAoISWRlbnRpdHkSDwoHZmxvd19pZBgBIAEoCRITCgtwcmltYXJ5X2tleRgCIAEoCRISCgpwcmltYXJ5X2lkGAMgASgJIrMFCgRDb2RlEgoKAmlkGAEgASgJEgwKBG5hbWUYAiABKAkSEwoLZGVzY3JpcHRpb24YAyABKAkSDgoGb3JnX2lkGAQgASgJEhQKDHdvcmtzcGFjZV9pZBgFIAEoCRIjCgdjcmVhdG9yGAYgASgLMhIuY29tbW9uLnYxLkNyZWF0b3ISGQoMYnJhbmRfa2l0X2lkGAcgASgJSACIAQESFgoJZG9tYWluX2lkGBEgASgJSAGIAQESFQoIYmF0Y2hfaWQYFCABKAlIAogBARINCgVzdGF0ZRgIIAEoCRITCgtmb2xkZXJfcGF0aBgJIAEoCRIMCgR0YWdzGAogAygJEhEKCWlzX3N0YXRpYxgLIAEoCBIRCglzaG9ydF91cmwYDCABKAkSEQoJbGlua19oYXNoGBIgASgJEhMKC2xpbmtfc3VmZml4GBUgASgJEisKDGRlc3RpbmF0aW9ucxgNIAMoCzIVLmNvZGVzLnYzLkRlc3RpbmF0aW9uEikKC2NvZGVfZGVzaWduGA4gASgLMhQuY29kZXMudjMuQ29kZURlc2lnbhIpCghtZXRhZGF0YRgTIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3QSJAoIaWRlbnRpdHkYFyABKAsyEi5jb2Rlcy52My5JZGVudGl0eRIuCgpjcmVhdGVkX2F0GA8gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GBAgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIyCghnczFfZGF0YRgWIAEoCzIcLmNvZGVzLnYzLkdTMURpZ2l0YWxMaW5rRGF0YUICGAFCDwoNX2JyYW5kX2tpdF9pZEIMCgpfZG9tYWluX2lkQgsKCV9iYXRjaF9pZCIxCgtDb2RlQ3JlYXRlZBIcCgRjb2RlGAEgASgLMg4uY29kZXMudjMuQ29kZToEiLUYASIxChFDcmVhdGVDb2RlUmVxdWVzdBIcCgRjb2RlGAEgASgLMg4uY29kZXMudjMuQ29kZSIyChJDcmVhdGVDb2RlUmVzcG9uc2USHAoEY29kZRgBIAEoCzIOLmNvZGVzLnYzLkNvZGUi5AIKEExpc3RDb2Rlc1JlcXVlc3QSDgoGb3JnX2lkGAEgASgJEhQKDHdvcmtzcGFjZV9pZBgCIAEoCRIYCgtmb2xkZXJfcGF0aBgDIAEoCUgAiAEBEhIKCmNyZWF0b3JfaWQYBSABKAkSEwoLbmFtZV9wcmVmaXgYBiABKAkSFwoKZXhhY3RfbmFtZRgKIAEoCUgBiAEBEgwKBHRhZ3MYByADKAkSEAoIYmF0Y2hfaWQYCCABKAkSDgoGc3RhdGVzGAkgAygJEh0KFW9taXRfZGVmYXVsdF9tZXRhZGF0YRgLIAEoCBIyCgpwYWdpbmF0aW9uGAQgASgLMh4uY29tbW9uLnYxLlBhZ2luYXRpb25Bcmd1bWVudHMSGgoNYmF0Y2hfdmVyc2lvbhgMIAEoCUgCiAEBQg4KDF9mb2xkZXJfcGF0aEINCgtfZXhhY3RfbmFtZUIQCg5fYmF0Y2hfdmVyc2lvbiJkChFMaXN0Q29kZXNSZXNwb25zZRIdCgVjb2RlcxgBIAMoCzIOLmNvZGVzLnYzLkNvZGUSMAoJcGFnZV9pbmZvGAIgASgLMh0uY29tbW9uLnYxLlBhZ2luYXRpb25QYWdlSW5mbyI7Cg5HZXRDb2RlUmVxdWVzdBIKCgJpZBgBIAEoCRIdChVvbWl0X2RlZmF1bHRfbWV0YWRhdGEYAiABKAgiLwoPR2V0Q29kZVJlc3BvbnNlEhwKBGNvZGUYASABKAsyDi5jb2Rlcy52My5Db2RlIoIBChVHZXRDb2RlSW5CYXRjaFJlcXVlc3QSCgoCaWQYASABKAkSEAoIYmF0Y2hfaWQYAiABKAkSGgoNYmF0Y2hfdmVyc2lvbhgDIAEoCUgAiAEBEh0KFW9taXRfZGVmYXVsdF9tZXRhZGF0YRgEIAEoCEIQCg5fYmF0Y2hfdmVyc2lvbiI2ChZHZXRDb2RlSW5CYXRjaFJlc3BvbnNlEhwKBGNvZGUYASABKAsyDi5jb2Rlcy52My5Db2RlIh4KD0dldENvZGVzUmVxdWVzdBILCgNpZHMYASADKAkiMQoQR2V0Q29kZXNSZXNwb25zZRIdCgVjb2RlcxgBIAMoCzIOLmNvZGVzLnYzLkNvZGUiYgoUUHJldmlld0Rlc2lnblJlcXVlc3QSFAoMYnJhbmRfa2l0X2lkGAEgASgJEikKBmRlc2lnbhgCIAEoCzIULmNvZGVzLnYzLkNvZGVEZXNpZ25IAIgBAUIJCgdfZGVzaWduIkIKFVByZXZpZXdEZXNpZ25SZXNwb25zZRIpCgtjb2RlX2Rlc2lnbhgBIAEoCzIULmNvZGVzLnYzLkNvZGVEZXNpZ24iiQEKEVVwZGF0ZUNvZGVSZXF1ZXN0EhwKBGNvZGUYASABKAsyDi5jb2Rlcy52My5Db2RlEigKBG1hc2sYAiABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrEhoKDWJhdGNoX3ZlcnNpb24YAyABKAlIAIgBAUIQCg5fYmF0Y2hfdmVyc2lvbiIyChJVcGRhdGVDb2RlUmVzcG9uc2USHAoEY29kZRgBIAEoCzIOLmNvZGVzLnYzLkNvZGUiHwoRRGVsZXRlQ29kZVJlcXVlc3QSCgoCaWQYASABKAkiFAoSRGVsZXRlQ29kZVJlc3BvbnNlItsCChVBZGRDb2RlVG9CYXRjaFJlcXVlc3QSDgoGb3JnX2lkGAEgASgJEhQKDHdvcmtzcGFjZV9pZBgCIAEoCRIQCghiYXRjaF9pZBgDIAEoCRIMCgRuYW1lGAQgASgJEhMKC2Rlc2NyaXB0aW9uGAUgASgJEgwKBHRhZ3MYBiADKAkSEwoLbGlua19zdWZmaXgYCCABKAkSEQoJbGlua19oYXNoGAsgASgJEikKCG1ldGFkYXRhGAcgASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdBIkCghpZGVudGl0eRgXIAEoCzISLmNvZGVzLnYzLklkZW50aXR5EhoKDWJhdGNoX3ZlcnNpb24YCSABKAlIAIgBARIyCghnczFfZGF0YRgKIAEoCzIcLmNvZGVzLnYzLkdTMURpZ2l0YWxMaW5rRGF0YUICGAFCEAoOX2JhdGNoX3ZlcnNpb24iNgoWQWRkQ29kZVRvQmF0Y2hSZXNwb25zZRIcCgRjb2RlGAEgASgLMg4uY29kZXMudjMuQ29kZSKxAQoWQWRkQ29kZXNUb0JhdGNoUmVxdWVzdBIOCgZvcmdfaWQYASABKAkSFAoMd29ya3NwYWNlX2lkGAIgASgJEhAKCGJhdGNoX2lkGAMgASgJEjEKCHJlcXVlc3RzGAQgAygLMh8uY29kZXMudjMuQWRkQ29kZVRvQmF0Y2hSZXF1ZXN0EhoKDWJhdGNoX3ZlcnNpb24YBSABKAlIAIgBAUIQCg5fYmF0Y2hfdmVyc2lvbiI4ChdBZGRDb2Rlc1RvQmF0Y2hSZXNwb25zZRIdCgVjb2RlcxgBIAMoCzIOLmNvZGVzLnYzLkNvZGUitAEKGVVwc2VydENvZGVzSW5CYXRjaFJlcXVlc3QSDgoGb3JnX2lkGAEgASgJEhQKDHdvcmtzcGFjZV9pZBgCIAEoCRIQCghiYXRjaF9pZBgDIAEoCRIxCghyZXF1ZXN0cxgEIAMoCzIfLmNvZGVzLnYzLkFkZENvZGVUb0JhdGNoUmVxdWVzdBIaCg1iYXRjaF92ZXJzaW9uGAUgASgJSACIAQFCEAoOX2JhdGNoX3ZlcnNpb24iXgoaVXBzZXJ0Q29kZXNJbkJhdGNoUmVzcG9uc2USHwoHY3JlYXRlZBgBIAMoCzIOLmNvZGVzLnYzLkNvZGUSHwoHdXBkYXRlZBgCIAMoCzIOLmNvZGVzLnYzLkNvZGUiggEKGVVwZGF0ZUNvZGVzSW5CYXRjaFJlcXVlc3QSDgoGb3JnX2lkGAEgASgJEhQKDHdvcmtzcGFjZV9pZBgCIAEoCRIQCghiYXRjaF9pZBgDIAEoCRItCghyZXF1ZXN0cxgEIAMoCzIbLmNvZGVzLnYzLlVwZGF0ZUNvZGVSZXF1ZXN0IjsKGlVwZGF0ZUNvZGVzSW5CYXRjaFJlc3BvbnNlEh0KBWNvZGVzGAEgAygLMg4uY29kZXMudjMuQ29kZSLUAgoWQnVsa0ltcG9ydENvZGVzUmVxdWVzdBIOCgZvcmdfaWQYASABKAkSFAoMd29ya3NwYWNlX2lkGAIgASgJEhAKCGJhdGNoX2lkGAMgASgJEhAKCGZpbGVfdXJsGAQgASgJEhMKC2F1ZGllbmNlX2lkGAkgASgJEj4KB21hcHBpbmcYBSADKAsyLS5jb2Rlcy52My5CdWxrSW1wb3J0Q29kZXNSZXF1ZXN0Lk1hcHBpbmdFbnRyeRISCgpoYXNfaGVhZGVyGAYgASgIEg4KBmhlYWRlchgHIAMoCRIaCg1iYXRjaF92ZXJzaW9uGAggASgJSACIAQEaSQoMTWFwcGluZ0VudHJ5EgsKA2tleRgBIAEoCRIoCgV2YWx1ZRgCIAEoCzIZLndvcmtmbG93cy52MS5NYXBwZWRWYWx1ZToCOAFCEAoOX2JhdGNoX3ZlcnNpb24iGQoXQnVsa0ltcG9ydENvZGVzUmVzcG9uc2UidgoRRXhwb3J0Q29kZVJlcXVlc3QSCgoCaWQYASABKAkSIgoEc2luaxgCIAEoCzIULmNvZGVzLnYzLk91dHB1dFNpbmsSJAoGZm9ybWF0GAMgASgOMhQuY29kZXMudjMuRmlsZUZvcm1hdBILCgNkcGkYBCABKAUiIQoSRXhwb3J0Q29kZVJlc3BvbnNlEgsKA3VybBgBIAEoCSLCAQoWQnVsa0V4cG9ydENvZGVzUmVxdWVzdBInCgNyZXEYASABKAsyGi5jb2Rlcy52My5MaXN0Q29kZXNSZXF1ZXN0EiIKBHNpbmsYAiABKAsyFC5jb2Rlcy52My5PdXRwdXRTaW5rEiQKBmZvcm1hdBgDIAEoDjIULmNvZGVzLnYzLkZpbGVGb3JtYXQSCwoDZHBpGAQgASgFEhgKEGVtYWlsX3JlY2lwaWVudHMYBSADKAkSDgoGbm90aWZ5GAYgASgIIioKF0J1bGtFeHBvcnRDb2Rlc1Jlc3BvbnNlEg8KB3ppcF91cmwYASABKAkixAEKFkV4cG9ydENvZGVNYXNrc1JlcXVlc3QSJwoDcmVxGAEgASgLMhouY29kZXMudjMuTGlzdENvZGVzUmVxdWVzdBIiCgRzaW5rGAIgASgLMhQuY29kZXMudjMuT3V0cHV0U2luaxIkCgZmb3JtYXQYAyABKA4yFC5jb2Rlcy52My5GaWxlRm9ybWF0EgsKA2RwaRgEIAEoBRIZCgx3aWR0aF9pbmNoZXMYBSABKAFIAIgBAUIPCg1fd2lkdGhfaW5jaGVzIioKF0V4cG9ydENvZGVNYXNrc1Jlc3BvbnNlEg8KB3ppcF91cmwYASABKAkiKwoIUzNCdWNrZXQSDAoEbmFtZRgBIAEoCRIRCglkaXJlY3RvcnkYAiABKAkiPgoKT3V0cHV0U2luaxIkCgZidWNrZXQYASABKAsyEi5jb2Rlcy52My5TM0J1Y2tldEgAQgoKCGxvY2F0aW9uIvQECgVCYXRjaBIKCgJpZBgBIAEoCRIPCgd2ZXJzaW9uGBQgASgJEgwKBG5hbWUYAiABKAkSEwoLZGVzY3JpcHRpb24YAyABKAkSDgoGb3JnX2lkGAQgASgJEhQKDHdvcmtzcGFjZV9pZBgFIAEoCRIjCgdjcmVhdG9yGAYgASgLMhIuY29tbW9uLnYxLkNyZWF0b3ISGQoMYnJhbmRfa2l0X2lkGAcgASgJSACIAQESFgoJZG9tYWluX2lkGAggASgJSAGIAQESEwoGZG9tYWluGBIgASgJSAKIAQESDQoFc3RhdGUYCSABKAkSEwoLZm9sZGVyX3BhdGgYCiABKAkSDAoEdGFncxgLIAMoCRIvChBiYXNlX2Rlc3RpbmF0aW9uGAwgASgLMhUuY29kZXMudjMuRGVzdGluYXRpb24SEwoLbGlua19zdWZmaXgYEyABKAkSKQoLYmFzZV9kZXNpZ24YDSABKAsyFC5jb2Rlcy52My5Db2RlRGVzaWduEikKCG1ldGFkYXRhGA4gASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdBIXCg9tZXRhZGF0YV9zY2hlbWEYESABKAkSLgoKY3JlYXRlZF9hdBgPIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgQIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASJwoKYmF0Y2hfdHlwZRgVIAEoDjITLmNvZGVzLnYzLkJhdGNoVHlwZUIPCg1fYnJhbmRfa2l0X2lkQgwKCl9kb21haW5faWRCCQoHX2RvbWFpbiI0ChJDcmVhdGVCYXRjaFJlcXVlc3QSHgoFYmF0Y2gYASABKAsyDy5jb2Rlcy52My5CYXRjaCI1ChNDcmVhdGVCYXRjaFJlc3BvbnNlEh4KBWJhdGNoGAEgASgLMg8uY29kZXMudjMuQmF0Y2giggMKHkNyZWF0ZUJhdGNoRnJvbVRlbXBsYXRlUmVxdWVzdBIOCgZvcmdfaWQYASABKAkSFAoMd29ya3NwYWNlX2lkGAIgASgJEhMKC3RlbXBsYXRlX2lkGAMgASgJEhgKEHRlbXBsYXRlX3ZlcnNpb24YDSABKAkSGQoMYnJhbmRfa2l0X2lkGAQgASgJSACIAQESFgoJZG9tYWluX2lkGAUgASgJSAGIAQESEwoLZm9sZGVyX3BhdGgYBiABKAkSDAoEbmFtZRgHIAEoCRITCgtkZXNjcmlwdGlvbhgIIAEoCRIMCgR0YWdzGAkgAygJEi8KEGJhc2VfZGVzdGluYXRpb24YCiABKAsyFS5jb2Rlcy52My5EZXN0aW5hdGlvbhIpCghtZXRhZGF0YRgLIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3QSFwoPbWV0YWRhdGFfc2NoZW1hGAwgASgJQg8KDV9icmFuZF9raXRfaWRCDAoKX2RvbWFpbl9pZCJBCh9DcmVhdGVCYXRjaEZyb21UZW1wbGF0ZVJlc3BvbnNlEh4KBWJhdGNoGAEgASgLMg8uY29kZXMudjMuQmF0Y2gi3wEKEkxpc3RCYXRjaGVzUmVxdWVzdBIOCgZvcmdfaWQYASABKAkSFAoMd29ya3NwYWNlX2lkGAIgASgJEhgKC2ZvbGRlcl9wYXRoGAMgASgJSACIAQESEgoKY3JlYXRvcl9pZBgFIAEoCRITCgtuYW1lX3ByZWZpeBgGIAEoCRIMCgR0YWdzGAcgAygJEg4KBnN0YXRlcxgIIAMoCRIyCgpwYWdpbmF0aW9uGAQgASgLMh4uY29tbW9uLnYxLlBhZ2luYXRpb25Bcmd1bWVudHNCDgoMX2ZvbGRlcl9wYXRoImkKE0xpc3RCYXRjaGVzUmVzcG9uc2USIAoHYmF0Y2hlcxgBIAMoCzIPLmNvZGVzLnYzLkJhdGNoEjAKCXBhZ2VfaW5mbxgCIAEoCzIdLmNvbW1vbi52MS5QYWdpbmF0aW9uUGFnZUluZm8iLgoPR2V0QmF0Y2hSZXF1ZXN0EgoKAmlkGAEgASgJEg8KB3ZlcnNpb24YAiABKAkiMgoQR2V0QmF0Y2hSZXNwb25zZRIeCgViYXRjaBgBIAEoCzIPLmNvZGVzLnYzLkJhdGNoIl4KElVwZGF0ZUJhdGNoUmVxdWVzdBIeCgViYXRjaBgBIAEoCzIPLmNvZGVzLnYzLkJhdGNoEigKBG1hc2sYAiABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrIjUKE1VwZGF0ZUJhdGNoUmVzcG9uc2USHgoFYmF0Y2gYASABKAsyDy5jb2Rlcy52My5CYXRjaCIxChJEZWxldGVCYXRjaFJlcXVlc3QSCgoCaWQYASABKAkSDwoHdmVyc2lvbhgCIAEoCSIVChNEZWxldGVCYXRjaFJlc3BvbnNlIicKGURlbGV0ZUNvZGVzSW5CYXRjaFJlcXVlc3QSCgoCaWQYASABKAkiHAoaRGVsZXRlQ29kZXNJbkJhdGNoUmVzcG9uc2Ui/wMKDUJhdGNoVGVtcGxhdGUSCgoCaWQYASABKAkSDwoHdmVyc2lvbhgRIAEoCRIMCgRuYW1lGAIgASgJEhMKC2Rlc2NyaXB0aW9uGAMgASgJEg4KBm9yZ19pZBgEIAEoCRIUCgx3b3Jrc3BhY2VfaWQYBSABKAkSIwoHY3JlYXRvchgGIAEoCzISLmNvbW1vbi52MS5DcmVhdG9yEhkKDGJyYW5kX2tpdF9pZBgHIAEoCUgAiAEBEhYKCWRvbWFpbl9pZBgIIAEoCUgBiAEBEg0KBXN0YXRlGAkgASgJEhIKCnZpc2liaWxpdHkYECABKAkSEwoLZm9sZGVyX3BhdGgYCiABKAkSDAoEdGFncxgLIAMoCRIpCgtiYXNlX2Rlc2lnbhgMIAEoCzIULmNvZGVzLnYzLkNvZGVEZXNpZ24SFwoPbWV0YWRhdGFfc2NoZW1hGA8gASgJEi4KCmNyZWF0ZWRfYXQYDSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYDiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEicKCmJhdGNoX3R5cGUYEiABKA4yEy5jb2Rlcy52My5CYXRjaFR5cGVCDwoNX2JyYW5kX2tpdF9pZEIMCgpfZG9tYWluX2lkIkcKGkNyZWF0ZUJhdGNoVGVtcGxhdGVSZXF1ZXN0EikKCHRlbXBsYXRlGAEgASgLMhcuY29kZXMudjMuQmF0Y2hUZW1wbGF0ZSJIChtDcmVhdGVCYXRjaFRlbXBsYXRlUmVzcG9uc2USKQoIdGVtcGxhdGUYASABKAsyFy5jb2Rlcy52My5CYXRjaFRlbXBsYXRlIokBCiFDcmVhdGVCYXRjaFRlbXBsYXRlVmVyc2lvblJlcXVlc3QSCgoCaWQYASABKAkSEwoHdmVyc2lvbhgCIAEoCUICGAESLQoJaW5jcmVtZW50GAQgASgOMhouYXNzZXQudjEuVmVyc2lvbkluY3JlbWVudBIUCgxiYXNlX3ZlcnNpb24YAyABKAkiTwoiQ3JlYXRlQmF0Y2hUZW1wbGF0ZVZlcnNpb25SZXNwb25zZRIpCgh0ZW1wbGF0ZRgBIAEoCzIXLmNvZGVzLnYzLkJhdGNoVGVtcGxhdGUiVQoiUHVibGlzaEJhdGNoVGVtcGxhdGVWZXJzaW9uUmVxdWVzdBIKCgJpZBgBIAEoCRIPCgd2ZXJzaW9uGAIgASgJEhIKCnZpc2liaWxpdHkYAyABKAkiUAojUHVibGlzaEJhdGNoVGVtcGxhdGVWZXJzaW9uUmVzcG9uc2USKQoIdGVtcGxhdGUYASABKAsyFy5jb2Rlcy52My5CYXRjaFRlbXBsYXRlItYBChlMaXN0QmF0Y2hUZW1wbGF0ZXNSZXF1ZXN0Eg4KBm9yZ19pZBgBIAEoCRIUCgx3b3Jrc3BhY2VfaWQYAiABKAkSGAoLZm9sZGVyX3BhdGgYAyABKAlIAIgBARISCgpjcmVhdG9yX2lkGAUgASgJEhMKC25hbWVfcHJlZml4GAYgASgJEgwKBHRhZ3MYByADKAkSMgoKcGFnaW5hdGlvbhgEIAEoCzIeLmNvbW1vbi52MS5QYWdpbmF0aW9uQXJndW1lbnRzQg4KDF9mb2xkZXJfcGF0aCJ6ChpMaXN0QmF0Y2hUZW1wbGF0ZXNSZXNwb25zZRIqCgl0ZW1wbGF0ZXMYASADKAsyFy5jb2Rlcy52My5CYXRjaFRlbXBsYXRlEjAKCXBhZ2VfaW5mbxgCIAEoCzIdLmNvbW1vbi52MS5QYWdpbmF0aW9uUGFnZUluZm8iNgoXR2V0QmF0Y2hUZW1wbGF0ZVJlcXVlc3QSCgoCaWQYASABKAkSDwoHdmVyc2lvbhgCIAEoCSJFChhHZXRCYXRjaFRlbXBsYXRlUmVzcG9uc2USKQoIdGVtcGxhdGUYASABKAsyFy5jb2Rlcy52My5CYXRjaFRlbXBsYXRlInEKGlVwZGF0ZUJhdGNoVGVtcGxhdGVSZXF1ZXN0EikKCHRlbXBsYXRlGAEgASgLMhcuY29kZXMudjMuQmF0Y2hUZW1wbGF0ZRIoCgRtYXNrGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLkZpZWxkTWFzayJIChtVcGRhdGVCYXRjaFRlbXBsYXRlUmVzcG9uc2USKQoIdGVtcGxhdGUYASABKAsyFy5jb2Rlcy52My5CYXRjaFRlbXBsYXRlIigKGkRlbGV0ZUJhdGNoVGVtcGxhdGVSZXF1ZXN0EgoKAmlkGAEgASgJIh0KG0RlbGV0ZUJhdGNoVGVtcGxhdGVSZXNwb25zZSLoAgoMU3R1ZGlvQ29uZmlnEgoKAmlkGAEgASgJEg8KB3ZlcnNpb24YDiABKAkSDAoEbmFtZRgCIAEoCRITCgtkZXNjcmlwdGlvbhgDIAEoCRIOCgZvcmdfaWQYBCABKAkSFAoMd29ya3NwYWNlX2lkGAUgASgJEiMKB2NyZWF0b3IYBiABKAsyEi5jb21tb24udjEuQ3JlYXRvchINCgVzdGF0ZRgHIAEoCRISCgp2aXNpYmlsaXR5GA0gASgJEhMKC2ZvbGRlcl9wYXRoGAggASgJEgwKBHRhZ3MYCSADKAkSJwoGY29uZmlnGAogASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdBIuCgpjcmVhdGVkX2F0GAsgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GAwgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCJKChlDcmVhdGVTdHVkaW9Db25maWdSZXF1ZXN0Ei0KDXN0dWRpb19jb25maWcYASABKAsyFi5jb2Rlcy52My5TdHVkaW9Db25maWciSwoaQ3JlYXRlU3R1ZGlvQ29uZmlnUmVzcG9uc2USLQoNc3R1ZGlvX2NvbmZpZxgBIAEoCzIWLmNvZGVzLnYzLlN0dWRpb0NvbmZpZyI1ChZHZXRTdHVkaW9Db25maWdSZXF1ZXN0EgoKAmlkGAEgASgJEg8KB3ZlcnNpb24YAiABKAkiSAoXR2V0U3R1ZGlvQ29uZmlnUmVzcG9uc2USLQoNc3R1ZGlvX2NvbmZpZxgBIAEoCzIWLmNvZGVzLnYzLlN0dWRpb0NvbmZpZyKIAQogQ3JlYXRlU3R1ZGlvQ29uZmlnVmVyc2lvblJlcXVlc3QSCgoCaWQYASABKAkSEwoHdmVyc2lvbhgCIAEoCUICGAESLQoJaW5jcmVtZW50GAQgASgOMhouYXNzZXQudjEuVmVyc2lvbkluY3JlbWVudBIUCgxiYXNlX3ZlcnNpb24YAyABKAkiUgohQ3JlYXRlU3R1ZGlvQ29uZmlnVmVyc2lvblJlc3BvbnNlEi0KDXN0dWRpb19jb25maWcYASABKAsyFi5jb2Rlcy52My5TdHVkaW9Db25maWciVAohUHVibGlzaFN0dWRpb0NvbmZpZ1ZlcnNpb25SZXF1ZXN0EgoKAmlkGAEgASgJEg8KB3ZlcnNpb24YAiABKAkSEgoKdmlzaWJpbGl0eRgDIAEoCSJTCiJQdWJsaXNoU3R1ZGlvQ29uZmlnVmVyc2lvblJlc3BvbnNlEi0KDXN0dWRpb19jb25maWcYASABKAsyFi5jb2Rlcy52My5TdHVkaW9Db25maWcidAoZVXBkYXRlU3R1ZGlvQ29uZmlnUmVxdWVzdBItCg1zdHVkaW9fY29uZmlnGAEgASgLMhYuY29kZXMudjMuU3R1ZGlvQ29uZmlnEigKBG1hc2sYAiABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrIksKGlVwZGF0ZVN0dWRpb0NvbmZpZ1Jlc3BvbnNlEi0KDXN0dWRpb19jb25maWcYASABKAsyFi5jb2Rlcy52My5TdHVkaW9Db25maWciJwoZRGVsZXRlU3R1ZGlvQ29uZmlnUmVxdWVzdBIKCgJpZBgBIAEoCSIcChpEZWxldGVTdHVkaW9Db25maWdSZXNwb25zZSLrAQoYTGlzdFN0dWRpb0NvbmZpZ3NSZXF1ZXN0Eg4KBm9yZ19pZBgBIAEoCRIUCgx3b3Jrc3BhY2VfaWQYAiABKAkSGAoLZm9sZGVyX3BhdGgYAyABKAlIAIgBARISCgpjcmVhdG9yX2lkGAUgASgJEhMKC25hbWVfcHJlZml4GAYgASgJEgwKBHRhZ3MYByADKAkSFAoMdmlzaWJpbGl0aWVzGAkgAygJEjIKCnBhZ2luYXRpb24YBCABKAsyHi5jb21tb24udjEuUGFnaW5hdGlvbkFyZ3VtZW50c0IOCgxfZm9sZGVyX3BhdGgifQoZTGlzdFN0dWRpb0NvbmZpZ3NSZXNwb25zZRIuCg5zdHVkaW9fY29uZmlncxgBIAMoCzIWLmNvZGVzLnYzLlN0dWRpb0NvbmZpZxIwCglwYWdlX2luZm8YAiABKAsyHS5jb21tb24udjEuUGFnaW5hdGlvblBhZ2VJbmZvKtkBCgpEZXNpZ25UeXBlEhsKF0RFU0lHTl9UWVBFX1VOU1BFQ0lGSUVEEAASHQoZREVTSUdOX1RZUEVfU1RVRElPX0NPTkZJRxABEh0KGURFU0lHTl9UWVBFX0NVU1RPTV9DT05GSUcQAhIgChxERVNJR05fVFlQRV9CUkFOREtJVF9ERVJJVkVEEAMSJgoiREVTSUdOX1RZUEVfQlJBTkRLSVRfU1RVRElPX0NPTkZJRxAEEiYKIkRFU0lHTl9UWVBFX0JSQU5ES0lUX0NVU1RPTV9DT05GSUcQBSqoAQoKRmlsZUZvcm1hdBIbChdGSUxFX0ZPUk1BVF9VTlNQRUNJRklFRBAAEhMKD0ZJTEVfRk9STUFUX1BORxABEhMKD0ZJTEVfRk9STUFUX0pQRxACEhMKD0ZJTEVfRk9STUFUX1NWRxADEhMKD0ZJTEVfRk9STUFUX1BERhAEEhMKD0ZJTEVfRk9STUFUX0VQUxAFEhQKEEZJTEVfRk9STUFUX1RJRkYQBipICglCYXRjaFR5cGUSGgoWQkFUQ0hfVFlQRV9VTlNQRUNJRklFRBAAEh8KG0JBVENIX1RZUEVfR1MxX0RJR0lUQUxfTElOSxABMp4cCgtDb2RlU2VydmljZRJPCgpDcmVhdGVDb2RlEhsuY29kZXMudjMuQ3JlYXRlQ29kZVJlcXVlc3QaHC5jb2Rlcy52My5DcmVhdGVDb2RlUmVzcG9uc2UiBsLtGgIIAhJMCglMaXN0Q29kZXMSGi5jb2Rlcy52My5MaXN0Q29kZXNSZXF1ZXN0GhsuY29kZXMudjMuTGlzdENvZGVzUmVzcG9uc2UiBsLtGgIIAhJECgdHZXRDb2RlEhguY29kZXMudjMuR2V0Q29kZVJlcXVlc3QaGS5jb2Rlcy52My5HZXRDb2RlUmVzcG9uc2UiBMLtGgASWQoOR2V0Q29kZUluQmF0Y2gSHy5jb2Rlcy52My5HZXRDb2RlSW5CYXRjaFJlcXVlc3QaIC5jb2Rlcy52My5HZXRDb2RlSW5CYXRjaFJlc3BvbnNlIgTC7RoAEkcKCEdldENvZGVzEhkuY29kZXMudjMuR2V0Q29kZXNSZXF1ZXN0GhouY29kZXMudjMuR2V0Q29kZXNSZXNwb25zZSIEwu0aABJPCgpVcGRhdGVDb2RlEhsuY29kZXMudjMuVXBkYXRlQ29kZVJlcXVlc3QaHC5jb2Rlcy52My5VcGRhdGVDb2RlUmVzcG9uc2UiBsLtGgIIAhJPCgpEZWxldGVDb2RlEhsuY29kZXMudjMuRGVsZXRlQ29kZVJlcXVlc3QaHC5jb2Rlcy52My5EZWxldGVDb2RlUmVzcG9uc2UiBsLtGgIIAhJbCg5BZGRDb2RlVG9CYXRjaBIfLmNvZGVzLnYzLkFkZENvZGVUb0JhdGNoUmVxdWVzdBogLmNvZGVzLnYzLkFkZENvZGVUb0JhdGNoUmVzcG9uc2UiBsLtGgIIAhJnChJVcHNlcnRDb2Rlc0luQmF0Y2gSIy5jb2Rlcy52My5VcHNlcnRDb2Rlc0luQmF0Y2hSZXF1ZXN0GiQuY29kZXMudjMuVXBzZXJ0Q29kZXNJbkJhdGNoUmVzcG9uc2UiBsLtGgIIAhJeCg9BZGRDb2Rlc1RvQmF0Y2gSIC5jb2Rlcy52My5BZGRDb2Rlc1RvQmF0Y2hSZXF1ZXN0GiEuY29kZXMudjMuQWRkQ29kZXNUb0JhdGNoUmVzcG9uc2UiBsLtGgIIAhJnChJVcGRhdGVDb2Rlc0luQmF0Y2gSIy5jb2Rlcy52My5VcGRhdGVDb2Rlc0luQmF0Y2hSZXF1ZXN0GiQuY29kZXMudjMuVXBkYXRlQ29kZXNJbkJhdGNoUmVzcG9uc2UiBsLtGgIIAhJPCgpFeHBvcnRDb2RlEhsuY29kZXMudjMuRXhwb3J0Q29kZVJlcXVlc3QaHC5jb2Rlcy52My5FeHBvcnRDb2RlUmVzcG9uc2UiBsLtGgIIAhJeCg9CdWxrRXhwb3J0Q29kZXMSIC5jb2Rlcy52My5CdWxrRXhwb3J0Q29kZXNSZXF1ZXN0GiEuY29kZXMudjMuQnVsa0V4cG9ydENvZGVzUmVzcG9uc2UiBsLtGgIIAhJeCg9FeHBvcnRDb2RlTWFza3MSIC5jb2Rlcy52My5FeHBvcnRDb2RlTWFza3NSZXF1ZXN0GiEuY29kZXMudjMuRXhwb3J0Q29kZU1hc2tzUmVzcG9uc2UiBsLtGgIIAhJeCg9CdWxrSW1wb3J0Q29kZXMSIC5jb2Rlcy52My5CdWxrSW1wb3J0Q29kZXNSZXF1ZXN0GiEuY29kZXMudjMuQnVsa0ltcG9ydENvZGVzUmVzcG9uc2UiBsLtGgIIAhJnChJDcmVhdGVTdHVkaW9Db25maWcSIy5jb2Rlcy52My5DcmVhdGVTdHVkaW9Db25maWdSZXF1ZXN0GiQuY29kZXMudjMuQ3JlYXRlU3R1ZGlvQ29uZmlnUmVzcG9uc2UiBsLtGgIIAhJ8ChlDcmVhdGVTdHVkaW9Db25maWdWZXJzaW9uEiouY29kZXMudjMuQ3JlYXRlU3R1ZGlvQ29uZmlnVmVyc2lvblJlcXVlc3QaKy5jb2Rlcy52My5DcmVhdGVTdHVkaW9Db25maWdWZXJzaW9uUmVzcG9uc2UiBsLtGgIIAhJ/ChpQdWJsaXNoU3R1ZGlvQ29uZmlnVmVyc2lvbhIrLmNvZGVzLnYzLlB1Ymxpc2hTdHVkaW9Db25maWdWZXJzaW9uUmVxdWVzdBosLmNvZGVzLnYzLlB1Ymxpc2hTdHVkaW9Db25maWdWZXJzaW9uUmVzcG9uc2UiBsLtGgIIAhJkChFMaXN0U3R1ZGlvQ29uZmlncxIiLmNvZGVzLnYzLkxpc3RTdHVkaW9Db25maWdzUmVxdWVzdBojLmNvZGVzLnYzLkxpc3RTdHVkaW9Db25maWdzUmVzcG9uc2UiBsLtGgIIAhJcCg9HZXRTdHVkaW9Db25maWcSIC5jb2Rlcy52My5HZXRTdHVkaW9Db25maWdSZXF1ZXN0GiEuY29kZXMudjMuR2V0U3R1ZGlvQ29uZmlnUmVzcG9uc2UiBMLtGgASZwoSVXBkYXRlU3R1ZGlvQ29uZmlnEiMuY29kZXMudjMuVXBkYXRlU3R1ZGlvQ29uZmlnUmVxdWVzdBokLmNvZGVzLnYzLlVwZGF0ZVN0dWRpb0NvbmZpZ1Jlc3BvbnNlIgbC7RoCCAISZwoSRGVsZXRlU3R1ZGlvQ29uZmlnEiMuY29kZXMudjMuRGVsZXRlU3R1ZGlvQ29uZmlnUmVxdWVzdBokLmNvZGVzLnYzLkRlbGV0ZVN0dWRpb0NvbmZpZ1Jlc3BvbnNlIgbC7RoCCAISUgoLQ3JlYXRlQmF0Y2gSHC5jb2Rlcy52My5DcmVhdGVCYXRjaFJlcXVlc3QaHS5jb2Rlcy52My5DcmVhdGVCYXRjaFJlc3BvbnNlIgbC7RoCCAISdgoXQ3JlYXRlQmF0Y2hGcm9tVGVtcGxhdGUSKC5jb2Rlcy52My5DcmVhdGVCYXRjaEZyb21UZW1wbGF0ZVJlcXVlc3QaKS5jb2Rlcy52My5DcmVhdGVCYXRjaEZyb21UZW1wbGF0ZVJlc3BvbnNlIgbC7RoCCAISUgoLTGlzdEJhdGNoZXMSHC5jb2Rlcy52My5MaXN0QmF0Y2hlc1JlcXVlc3QaHS5jb2Rlcy52My5MaXN0QmF0Y2hlc1Jlc3BvbnNlIgbC7RoCCAISRwoIR2V0QmF0Y2gSGS5jb2Rlcy52My5HZXRCYXRjaFJlcXVlc3QaGi5jb2Rlcy52My5HZXRCYXRjaFJlc3BvbnNlIgTC7RoAElIKC1VwZGF0ZUJhdGNoEhwuY29kZXMudjMuVXBkYXRlQmF0Y2hSZXF1ZXN0Gh0uY29kZXMudjMuVXBkYXRlQmF0Y2hSZXNwb25zZSIGwu0aAggCElIKC0RlbGV0ZUJhdGNoEhwuY29kZXMudjMuRGVsZXRlQmF0Y2hSZXF1ZXN0Gh0uY29kZXMudjMuRGVsZXRlQmF0Y2hSZXNwb25zZSIGwu0aAggCEmcKEkRlbGV0ZUNvZGVzSW5CYXRjaBIjLmNvZGVzLnYzLkRlbGV0ZUNvZGVzSW5CYXRjaFJlcXVlc3QaJC5jb2Rlcy52My5EZWxldGVDb2Rlc0luQmF0Y2hSZXNwb25zZSIGwu0aAggCEmoKE0NyZWF0ZUJhdGNoVGVtcGxhdGUSJC5jb2Rlcy52My5DcmVhdGVCYXRjaFRlbXBsYXRlUmVxdWVzdBolLmNvZGVzLnYzLkNyZWF0ZUJhdGNoVGVtcGxhdGVSZXNwb25zZSIGwu0aAggCEn8KGkNyZWF0ZUJhdGNoVGVtcGxhdGVWZXJzaW9uEisuY29kZXMudjMuQ3JlYXRlQmF0Y2hUZW1wbGF0ZVZlcnNpb25SZXF1ZXN0GiwuY29kZXMudjMuQ3JlYXRlQmF0Y2hUZW1wbGF0ZVZlcnNpb25SZXNwb25zZSIGwu0aAggCEoIBChtQdWJsaXNoQmF0Y2hUZW1wbGF0ZVZlcnNpb24SLC5jb2Rlcy52My5QdWJsaXNoQmF0Y2hUZW1wbGF0ZVZlcnNpb25SZXF1ZXN0Gi0uY29kZXMudjMuUHVibGlzaEJhdGNoVGVtcGxhdGVWZXJzaW9uUmVzcG9uc2UiBsLtGgIIAhJnChJMaXN0QmF0Y2hUZW1wbGF0ZXMSIy5jb2Rlcy52My5MaXN0QmF0Y2hUZW1wbGF0ZXNSZXF1ZXN0GiQuY29kZXMudjMuTGlzdEJhdGNoVGVtcGxhdGVzUmVzcG9uc2UiBsLtGgIIAhJfChBHZXRCYXRjaFRlbXBsYXRlEiEuY29kZXMudjMuR2V0QmF0Y2hUZW1wbGF0ZVJlcXVlc3QaIi5jb2Rlcy52My5HZXRCYXRjaFRlbXBsYXRlUmVzcG9uc2UiBMLtGgASagoTVXBkYXRlQmF0Y2hUZW1wbGF0ZRIkLmNvZGVzLnYzLlVwZGF0ZUJhdGNoVGVtcGxhdGVSZXF1ZXN0GiUuY29kZXMudjMuVXBkYXRlQmF0Y2hUZW1wbGF0ZVJlc3BvbnNlIgbC7RoCCAISagoTRGVsZXRlQmF0Y2hUZW1wbGF0ZRIkLmNvZGVzLnYzLkRlbGV0ZUJhdGNoVGVtcGxhdGVSZXF1ZXN0GiUuY29kZXMudjMuRGVsZXRlQmF0Y2hUZW1wbGF0ZVJlc3BvbnNlIgbC7RoCCAISWAoNUHJldmlld0Rlc2lnbhIeLmNvZGVzLnYzLlByZXZpZXdEZXNpZ25SZXF1ZXN0Gh8uY29kZXMudjMuUHJldmlld0Rlc2lnblJlc3BvbnNlIgbC7RoCCAJiBnByb3RvMw",
		[file_asset_v1_asset, file_codes_v3_destination, file_common_v1_annotations, file_common_v1_events, file_common_v1_pagination, file_common_v1_types, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp, file_workflows_v1_workflows],
	);

/**
 * @generated from message codes.v3.CodeDesign
 */
export type CodeDesign = Message<"codes.v3.CodeDesign"> & {
	/**
	 * id represents the the studio_config_id
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 4;
	 */
	version: string;

	/**
	 * The configuration blob that holds the config required to render a flowcode
	 *
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: JsonObject | undefined;

	/**
	 * @generated from field: codes.v3.DesignType type = 3;
	 */
	type: DesignType;
};

/**
 * @generated from message codes.v3.CodeDesign
 */
export type CodeDesignJson = {
	/**
	 * id represents the the studio_config_id
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 4;
	 */
	version?: string;

	/**
	 * The configuration blob that holds the config required to render a flowcode
	 *
	 * @generated from field: google.protobuf.Struct config = 2;
	 */
	config?: StructJson;

	/**
	 * @generated from field: codes.v3.DesignType type = 3;
	 */
	type?: DesignTypeJson;
};

/**
 * Describes the message codes.v3.CodeDesign.
 * Use `create(CodeDesignSchema)` to create a new message.
 */
export const CodeDesignSchema: GenMessage<CodeDesign, { jsonType: CodeDesignJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 0);

/**
 * @generated from message codes.v3.Destination
 */
export type Destination = Message<"codes.v3.Destination"> & {
	/**
	 * Value is the redirect_value of the code
	 *
	 * @generated from field: string value = 1;
	 */
	value: string;

	/**
	 * Rule is an optional redirect rule attached to a code
	 *
	 * @generated from field: optional google.protobuf.Struct rule = 2;
	 */
	rule?: JsonObject | undefined;

	/**
	 * Type describes the "type" of destination a code leads to
	 *
	 * @generated from field: codes.v3.DestinationType type = 3;
	 */
	type: DestinationType;

	/**
	 * IsActive denotes whether the destination is active or not in the case
	 * where multiple destinations are stored per code
	 *
	 * @generated from field: bool is_active = 5;
	 */
	isActive: boolean;
};

/**
 * @generated from message codes.v3.Destination
 */
export type DestinationJson = {
	/**
	 * Value is the redirect_value of the code
	 *
	 * @generated from field: string value = 1;
	 */
	value?: string;

	/**
	 * Rule is an optional redirect rule attached to a code
	 *
	 * @generated from field: optional google.protobuf.Struct rule = 2;
	 */
	rule?: StructJson;

	/**
	 * Type describes the "type" of destination a code leads to
	 *
	 * @generated from field: codes.v3.DestinationType type = 3;
	 */
	type?: DestinationTypeJson;

	/**
	 * IsActive denotes whether the destination is active or not in the case
	 * where multiple destinations are stored per code
	 *
	 * @generated from field: bool is_active = 5;
	 */
	isActive?: boolean;
};

/**
 * Describes the message codes.v3.Destination.
 * Use `create(DestinationSchema)` to create a new message.
 */
export const DestinationSchema: GenMessage<Destination, { jsonType: DestinationJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 1);

/**
 * @generated from message codes.v3.Identity
 */
export type Identity = Message<"codes.v3.Identity"> & {
	/**
	 * @generated from field: string flow_id = 1;
	 */
	flowId: string;

	/**
	 * @generated from field: string primary_key = 2;
	 */
	primaryKey: string;

	/**
	 * @generated from field: string primary_id = 3;
	 */
	primaryId: string;
};

/**
 * @generated from message codes.v3.Identity
 */
export type IdentityJson = {
	/**
	 * @generated from field: string flow_id = 1;
	 */
	flowId?: string;

	/**
	 * @generated from field: string primary_key = 2;
	 */
	primaryKey?: string;

	/**
	 * @generated from field: string primary_id = 3;
	 */
	primaryId?: string;
};

/**
 * Describes the message codes.v3.Identity.
 * Use `create(IdentitySchema)` to create a new message.
 */
export const IdentitySchema: GenMessage<Identity, { jsonType: IdentityJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 2);

/**
 * Code is the representation of a flowcode containing:
 *   - the data it needs to render an image of it
 *   - the scan destination which determines the interaction a user has when scanning
 *
 * @generated from message codes.v3.Code
 */
export type Code = Message<"codes.v3.Code"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: optional string brand_kit_id = 7;
	 */
	brandKitId?: string | undefined;

	/**
	 * @generated from field: optional string domain_id = 17;
	 */
	domainId?: string | undefined;

	/**
	 * @generated from field: optional string batch_id = 20;
	 */
	batchId?: string | undefined;

	/**
	 * @generated from field: string state = 8;
	 */
	state: string;

	/**
	 * @generated from field: string folder_path = 9;
	 */
	folderPath: string;

	/**
	 * @generated from field: repeated string tags = 10;
	 */
	tags: string[];

	/**
	 * IsStatic is used to determine if the code is encoded with the short_url or just the value
	 *
	 * @generated from field: bool is_static = 11;
	 */
	isStatic: boolean;

	/**
	 * This is the url used to encode the flowcode.
	 *
	 * Shorturl uses a flowcode domain or in the case of white-label redirects
	 * it will contain a different domain
	 *
	 * @generated from field: string short_url = 12;
	 */
	shortUrl: string;

	/**
	 * @generated from field: string link_hash = 18;
	 */
	linkHash: string;

	/**
	 * @generated from field: string link_suffix = 21;
	 */
	linkSuffix: string;

	/**
	 * Destination describes what happens when a user scans the code
	 * Codes can contain multiple active and inactive destinations depending on which is toggle on
	 *
	 * @generated from field: repeated codes.v3.Destination destinations = 13;
	 */
	destinations: Destination[];

	/**
	 * CodeDesign describes what the code looks like
	 * The config is fed into the flowcode-generator-v2 which is responsible for interpretting the values
	 *
	 * @generated from field: codes.v3.CodeDesign code_design = 14;
	 */
	codeDesign?: CodeDesign | undefined;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 19;
	 */
	metadata?: JsonObject | undefined;

	/**
	 * @generated from field: codes.v3.Identity identity = 23;
	 */
	identity?: Identity | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 15;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 16;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: codes.v3.GS1DigitalLinkData gs1_data = 22 [deprecated = true];
	 * @deprecated
	 */
	gs1Data?: GS1DigitalLinkData | undefined;
};

/**
 * Code is the representation of a flowcode containing:
 *   - the data it needs to render an image of it
 *   - the scan destination which determines the interaction a user has when scanning
 *
 * @generated from message codes.v3.Code
 */
export type CodeJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: optional string brand_kit_id = 7;
	 */
	brandKitId?: string;

	/**
	 * @generated from field: optional string domain_id = 17;
	 */
	domainId?: string;

	/**
	 * @generated from field: optional string batch_id = 20;
	 */
	batchId?: string;

	/**
	 * @generated from field: string state = 8;
	 */
	state?: string;

	/**
	 * @generated from field: string folder_path = 9;
	 */
	folderPath?: string;

	/**
	 * @generated from field: repeated string tags = 10;
	 */
	tags?: string[];

	/**
	 * IsStatic is used to determine if the code is encoded with the short_url or just the value
	 *
	 * @generated from field: bool is_static = 11;
	 */
	isStatic?: boolean;

	/**
	 * This is the url used to encode the flowcode.
	 *
	 * Shorturl uses a flowcode domain or in the case of white-label redirects
	 * it will contain a different domain
	 *
	 * @generated from field: string short_url = 12;
	 */
	shortUrl?: string;

	/**
	 * @generated from field: string link_hash = 18;
	 */
	linkHash?: string;

	/**
	 * @generated from field: string link_suffix = 21;
	 */
	linkSuffix?: string;

	/**
	 * Destination describes what happens when a user scans the code
	 * Codes can contain multiple active and inactive destinations depending on which is toggle on
	 *
	 * @generated from field: repeated codes.v3.Destination destinations = 13;
	 */
	destinations?: DestinationJson[];

	/**
	 * CodeDesign describes what the code looks like
	 * The config is fed into the flowcode-generator-v2 which is responsible for interpretting the values
	 *
	 * @generated from field: codes.v3.CodeDesign code_design = 14;
	 */
	codeDesign?: CodeDesignJson;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 19;
	 */
	metadata?: StructJson;

	/**
	 * @generated from field: codes.v3.Identity identity = 23;
	 */
	identity?: IdentityJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 15;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 16;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: codes.v3.GS1DigitalLinkData gs1_data = 22 [deprecated = true];
	 * @deprecated
	 */
	gs1Data?: GS1DigitalLinkDataJson;
};

/**
 * Describes the message codes.v3.Code.
 * Use `create(CodeSchema)` to create a new message.
 */
export const CodeSchema: GenMessage<Code, { jsonType: CodeJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 3);

/**
 * @generated from message codes.v3.CodeCreated
 */
export type CodeCreated = Message<"codes.v3.CodeCreated"> & {
	/**
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: Code | undefined;
};

/**
 * @generated from message codes.v3.CodeCreated
 */
export type CodeCreatedJson = {
	/**
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: CodeJson;
};

/**
 * Describes the message codes.v3.CodeCreated.
 * Use `create(CodeCreatedSchema)` to create a new message.
 */
export const CodeCreatedSchema: GenMessage<CodeCreated, { jsonType: CodeCreatedJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 4);

/**
 * @generated from message codes.v3.CreateCodeRequest
 */
export type CreateCodeRequest = Message<"codes.v3.CreateCodeRequest"> & {
	/**
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: Code | undefined;
};

/**
 * @generated from message codes.v3.CreateCodeRequest
 */
export type CreateCodeRequestJson = {
	/**
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: CodeJson;
};

/**
 * Describes the message codes.v3.CreateCodeRequest.
 * Use `create(CreateCodeRequestSchema)` to create a new message.
 */
export const CreateCodeRequestSchema: GenMessage<CreateCodeRequest, { jsonType: CreateCodeRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 5);

/**
 * @generated from message codes.v3.CreateCodeResponse
 */
export type CreateCodeResponse = Message<"codes.v3.CreateCodeResponse"> & {
	/**
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: Code | undefined;
};

/**
 * @generated from message codes.v3.CreateCodeResponse
 */
export type CreateCodeResponseJson = {
	/**
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: CodeJson;
};

/**
 * Describes the message codes.v3.CreateCodeResponse.
 * Use `create(CreateCodeResponseSchema)` to create a new message.
 */
export const CreateCodeResponseSchema: GenMessage<CreateCodeResponse, { jsonType: CreateCodeResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 6);

/**
 * @generated from message codes.v3.ListCodesRequest
 */
export type ListCodesRequest = Message<"codes.v3.ListCodesRequest"> & {
	/**
	 * Org ID is the organization that the codes belong to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * Workspace ID is the workspace that the codes belong to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * Show only codes belonging to this folder path.
	 *
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string | undefined;

	/**
	 * Show only codes created by this creator id.
	 *
	 * @generated from field: string creator_id = 5;
	 */
	creatorId: string;

	/**
	 * Show only codes that include this prefix in the name.
	 *
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix: string;

	/**
	 * Show only codes with this exact name.
	 *
	 * @generated from field: optional string exact_name = 10;
	 */
	exactName?: string | undefined;

	/**
	 * Show only codes that include a tag from this list of tags.
	 *
	 * @generated from field: repeated string tags = 7;
	 */
	tags: string[];

	/**
	 * Show only codes that are in the batch with this batch id.
	 *
	 * @generated from field: string batch_id = 8;
	 */
	batchId: string;

	/**
	 * Show only codes that are in a state from this list of of states.
	 *
	 * @generated from field: repeated string states = 9;
	 */
	states: string[];

	/**
	 * Omit default metadata fields from the response.
	 *
	 * @generated from field: bool omit_default_metadata = 11;
	 */
	omitDefaultMetadata: boolean;

	/**
	 * Pagination arguments.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments | undefined;

	/**
	 * Use batch with a specific batch version.
	 *
	 * @generated from field: optional string batch_version = 12;
	 */
	batchVersion?: string | undefined;
};

/**
 * @generated from message codes.v3.ListCodesRequest
 */
export type ListCodesRequestJson = {
	/**
	 * Org ID is the organization that the codes belong to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * Workspace ID is the workspace that the codes belong to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * Show only codes belonging to this folder path.
	 *
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string;

	/**
	 * Show only codes created by this creator id.
	 *
	 * @generated from field: string creator_id = 5;
	 */
	creatorId?: string;

	/**
	 * Show only codes that include this prefix in the name.
	 *
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix?: string;

	/**
	 * Show only codes with this exact name.
	 *
	 * @generated from field: optional string exact_name = 10;
	 */
	exactName?: string;

	/**
	 * Show only codes that include a tag from this list of tags.
	 *
	 * @generated from field: repeated string tags = 7;
	 */
	tags?: string[];

	/**
	 * Show only codes that are in the batch with this batch id.
	 *
	 * @generated from field: string batch_id = 8;
	 */
	batchId?: string;

	/**
	 * Show only codes that are in a state from this list of of states.
	 *
	 * @generated from field: repeated string states = 9;
	 */
	states?: string[];

	/**
	 * Omit default metadata fields from the response.
	 *
	 * @generated from field: bool omit_default_metadata = 11;
	 */
	omitDefaultMetadata?: boolean;

	/**
	 * Pagination arguments.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;

	/**
	 * Use batch with a specific batch version.
	 *
	 * @generated from field: optional string batch_version = 12;
	 */
	batchVersion?: string;
};

/**
 * Describes the message codes.v3.ListCodesRequest.
 * Use `create(ListCodesRequestSchema)` to create a new message.
 */
export const ListCodesRequestSchema: GenMessage<ListCodesRequest, { jsonType: ListCodesRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 7);

/**
 * @generated from message codes.v3.ListCodesResponse
 */
export type ListCodesResponse = Message<"codes.v3.ListCodesResponse"> & {
	/**
	 * List of codes that match the query.
	 *
	 * @generated from field: repeated codes.v3.Code codes = 1;
	 */
	codes: Code[];

	/**
	 * Pagination information.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message codes.v3.ListCodesResponse
 */
export type ListCodesResponseJson = {
	/**
	 * List of codes that match the query.
	 *
	 * @generated from field: repeated codes.v3.Code codes = 1;
	 */
	codes?: CodeJson[];

	/**
	 * Pagination information.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message codes.v3.ListCodesResponse.
 * Use `create(ListCodesResponseSchema)` to create a new message.
 */
export const ListCodesResponseSchema: GenMessage<ListCodesResponse, { jsonType: ListCodesResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 8);

/**
 * @generated from message codes.v3.GetCodeRequest
 */
export type GetCodeRequest = Message<"codes.v3.GetCodeRequest"> & {
	/**
	 * ID of the code.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * Omit default metadata fields from the response.
	 *
	 * @generated from field: bool omit_default_metadata = 2;
	 */
	omitDefaultMetadata: boolean;
};

/**
 * @generated from message codes.v3.GetCodeRequest
 */
export type GetCodeRequestJson = {
	/**
	 * ID of the code.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * Omit default metadata fields from the response.
	 *
	 * @generated from field: bool omit_default_metadata = 2;
	 */
	omitDefaultMetadata?: boolean;
};

/**
 * Describes the message codes.v3.GetCodeRequest.
 * Use `create(GetCodeRequestSchema)` to create a new message.
 */
export const GetCodeRequestSchema: GenMessage<GetCodeRequest, { jsonType: GetCodeRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 9);

/**
 * @generated from message codes.v3.GetCodeResponse
 */
export type GetCodeResponse = Message<"codes.v3.GetCodeResponse"> & {
	/**
	 * Code that matched the query.
	 *
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: Code | undefined;
};

/**
 * @generated from message codes.v3.GetCodeResponse
 */
export type GetCodeResponseJson = {
	/**
	 * Code that matched the query.
	 *
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: CodeJson;
};

/**
 * Describes the message codes.v3.GetCodeResponse.
 * Use `create(GetCodeResponseSchema)` to create a new message.
 */
export const GetCodeResponseSchema: GenMessage<GetCodeResponse, { jsonType: GetCodeResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 10);

/**
 * @generated from message codes.v3.GetCodeInBatchRequest
 */
export type GetCodeInBatchRequest = Message<"codes.v3.GetCodeInBatchRequest"> & {
	/**
	 * ID of the code
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * ID of the batch to use.
	 *
	 * @generated from field: string batch_id = 2;
	 */
	batchId: string;

	/**
	 * Use batch with a specific batch version.
	 *
	 * @generated from field: optional string batch_version = 3;
	 */
	batchVersion?: string | undefined;

	/**
	 * Omit default metadata fields from the response.
	 *
	 * @generated from field: bool omit_default_metadata = 4;
	 */
	omitDefaultMetadata: boolean;
};

/**
 * @generated from message codes.v3.GetCodeInBatchRequest
 */
export type GetCodeInBatchRequestJson = {
	/**
	 * ID of the code
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * ID of the batch to use.
	 *
	 * @generated from field: string batch_id = 2;
	 */
	batchId?: string;

	/**
	 * Use batch with a specific batch version.
	 *
	 * @generated from field: optional string batch_version = 3;
	 */
	batchVersion?: string;

	/**
	 * Omit default metadata fields from the response.
	 *
	 * @generated from field: bool omit_default_metadata = 4;
	 */
	omitDefaultMetadata?: boolean;
};

/**
 * Describes the message codes.v3.GetCodeInBatchRequest.
 * Use `create(GetCodeInBatchRequestSchema)` to create a new message.
 */
export const GetCodeInBatchRequestSchema: GenMessage<GetCodeInBatchRequest, { jsonType: GetCodeInBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 11);

/**
 * @generated from message codes.v3.GetCodeInBatchResponse
 */
export type GetCodeInBatchResponse = Message<"codes.v3.GetCodeInBatchResponse"> & {
	/**
	 * Code that matched the query.
	 *
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: Code | undefined;
};

/**
 * @generated from message codes.v3.GetCodeInBatchResponse
 */
export type GetCodeInBatchResponseJson = {
	/**
	 * Code that matched the query.
	 *
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: CodeJson;
};

/**
 * Describes the message codes.v3.GetCodeInBatchResponse.
 * Use `create(GetCodeInBatchResponseSchema)` to create a new message.
 */
export const GetCodeInBatchResponseSchema: GenMessage<GetCodeInBatchResponse, { jsonType: GetCodeInBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 12);

/**
 * @generated from message codes.v3.GetCodesRequest
 */
export type GetCodesRequest = Message<"codes.v3.GetCodesRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];
};

/**
 * @generated from message codes.v3.GetCodesRequest
 */
export type GetCodesRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];
};

/**
 * Describes the message codes.v3.GetCodesRequest.
 * Use `create(GetCodesRequestSchema)` to create a new message.
 */
export const GetCodesRequestSchema: GenMessage<GetCodesRequest, { jsonType: GetCodesRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 13);

/**
 * @generated from message codes.v3.GetCodesResponse
 */
export type GetCodesResponse = Message<"codes.v3.GetCodesResponse"> & {
	/**
	 * @generated from field: repeated codes.v3.Code codes = 1;
	 */
	codes: Code[];
};

/**
 * @generated from message codes.v3.GetCodesResponse
 */
export type GetCodesResponseJson = {
	/**
	 * @generated from field: repeated codes.v3.Code codes = 1;
	 */
	codes?: CodeJson[];
};

/**
 * Describes the message codes.v3.GetCodesResponse.
 * Use `create(GetCodesResponseSchema)` to create a new message.
 */
export const GetCodesResponseSchema: GenMessage<GetCodesResponse, { jsonType: GetCodesResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 14);

/**
 * @generated from message codes.v3.PreviewDesignRequest
 */
export type PreviewDesignRequest = Message<"codes.v3.PreviewDesignRequest"> & {
	/**
	 * @generated from field: string brand_kit_id = 1;
	 */
	brandKitId: string;

	/**
	 * @generated from field: optional codes.v3.CodeDesign design = 2;
	 */
	design?: CodeDesign | undefined;
};

/**
 * @generated from message codes.v3.PreviewDesignRequest
 */
export type PreviewDesignRequestJson = {
	/**
	 * @generated from field: string brand_kit_id = 1;
	 */
	brandKitId?: string;

	/**
	 * @generated from field: optional codes.v3.CodeDesign design = 2;
	 */
	design?: CodeDesignJson;
};

/**
 * Describes the message codes.v3.PreviewDesignRequest.
 * Use `create(PreviewDesignRequestSchema)` to create a new message.
 */
export const PreviewDesignRequestSchema: GenMessage<PreviewDesignRequest, { jsonType: PreviewDesignRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 15);

/**
 * @generated from message codes.v3.PreviewDesignResponse
 */
export type PreviewDesignResponse = Message<"codes.v3.PreviewDesignResponse"> & {
	/**
	 * @generated from field: codes.v3.CodeDesign code_design = 1;
	 */
	codeDesign?: CodeDesign | undefined;
};

/**
 * @generated from message codes.v3.PreviewDesignResponse
 */
export type PreviewDesignResponseJson = {
	/**
	 * @generated from field: codes.v3.CodeDesign code_design = 1;
	 */
	codeDesign?: CodeDesignJson;
};

/**
 * Describes the message codes.v3.PreviewDesignResponse.
 * Use `create(PreviewDesignResponseSchema)` to create a new message.
 */
export const PreviewDesignResponseSchema: GenMessage<PreviewDesignResponse, { jsonType: PreviewDesignResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 16);

/**
 * @generated from message codes.v3.UpdateCodeRequest
 */
export type UpdateCodeRequest = Message<"codes.v3.UpdateCodeRequest"> & {
	/**
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: Code | undefined;

	/**
	 * Mask of fields to update.
	 *
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;

	/**
	 * version of the batch
	 *
	 * @generated from field: optional string batch_version = 3;
	 */
	batchVersion?: string | undefined;
};

/**
 * @generated from message codes.v3.UpdateCodeRequest
 */
export type UpdateCodeRequestJson = {
	/**
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: CodeJson;

	/**
	 * Mask of fields to update.
	 *
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;

	/**
	 * version of the batch
	 *
	 * @generated from field: optional string batch_version = 3;
	 */
	batchVersion?: string;
};

/**
 * Describes the message codes.v3.UpdateCodeRequest.
 * Use `create(UpdateCodeRequestSchema)` to create a new message.
 */
export const UpdateCodeRequestSchema: GenMessage<UpdateCodeRequest, { jsonType: UpdateCodeRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 17);

/**
 * @generated from message codes.v3.UpdateCodeResponse
 */
export type UpdateCodeResponse = Message<"codes.v3.UpdateCodeResponse"> & {
	/**
	 * Updated code.
	 *
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: Code | undefined;
};

/**
 * @generated from message codes.v3.UpdateCodeResponse
 */
export type UpdateCodeResponseJson = {
	/**
	 * Updated code.
	 *
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: CodeJson;
};

/**
 * Describes the message codes.v3.UpdateCodeResponse.
 * Use `create(UpdateCodeResponseSchema)` to create a new message.
 */
export const UpdateCodeResponseSchema: GenMessage<UpdateCodeResponse, { jsonType: UpdateCodeResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 18);

/**
 * @generated from message codes.v3.DeleteCodeRequest
 */
export type DeleteCodeRequest = Message<"codes.v3.DeleteCodeRequest"> & {
	/**
	 * ID of the code.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message codes.v3.DeleteCodeRequest
 */
export type DeleteCodeRequestJson = {
	/**
	 * ID of the code.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message codes.v3.DeleteCodeRequest.
 * Use `create(DeleteCodeRequestSchema)` to create a new message.
 */
export const DeleteCodeRequestSchema: GenMessage<DeleteCodeRequest, { jsonType: DeleteCodeRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 19);

/**
 * @generated from message codes.v3.DeleteCodeResponse
 */
export type DeleteCodeResponse = Message<"codes.v3.DeleteCodeResponse"> & {};

/**
 * @generated from message codes.v3.DeleteCodeResponse
 */
export type DeleteCodeResponseJson = {};

/**
 * Describes the message codes.v3.DeleteCodeResponse.
 * Use `create(DeleteCodeResponseSchema)` to create a new message.
 */
export const DeleteCodeResponseSchema: GenMessage<DeleteCodeResponse, { jsonType: DeleteCodeResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 20);

/**
 * @generated from message codes.v3.AddCodeToBatchRequest
 */
export type AddCodeToBatchRequest = Message<"codes.v3.AddCodeToBatchRequest"> & {
	/**
	 * Org ID is the organization that the batch belongs to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * Workspace ID is the workspace that the batch belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * Batch ID is the batch that the code will be added to.
	 *
	 * @generated from field: string batch_id = 3;
	 */
	batchId: string;

	/**
	 * Name of the code.
	 *
	 * @generated from field: string name = 4;
	 */
	name: string;

	/**
	 * Description of the code.
	 *
	 * @generated from field: string description = 5;
	 */
	description: string;

	/**
	 * Add a list of tags to the code.
	 *
	 * @generated from field: repeated string tags = 6;
	 */
	tags: string[];

	/**
	 * Add a link suffix associated with the code.
	 *
	 * @generated from field: string link_suffix = 8;
	 */
	linkSuffix: string;

	/**
	 * The link hash for the code's short URL.
	 *
	 * @generated from field: string link_hash = 11;
	 */
	linkHash: string;

	/**
	 * Add data properties to the code.
	 *
	 * @generated from field: google.protobuf.Struct metadata = 7;
	 */
	metadata?: JsonObject | undefined;

	/**
	 * Associate identity to the code.
	 *
	 * @generated from field: codes.v3.Identity identity = 23;
	 */
	identity?: Identity | undefined;

	/**
	 * version of the batch
	 *
	 * @generated from field: optional string batch_version = 9;
	 */
	batchVersion?: string | undefined;

	/**
	 * @generated from field: codes.v3.GS1DigitalLinkData gs1_data = 10 [deprecated = true];
	 * @deprecated
	 */
	gs1Data?: GS1DigitalLinkData | undefined;
};

/**
 * @generated from message codes.v3.AddCodeToBatchRequest
 */
export type AddCodeToBatchRequestJson = {
	/**
	 * Org ID is the organization that the batch belongs to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * Workspace ID is the workspace that the batch belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * Batch ID is the batch that the code will be added to.
	 *
	 * @generated from field: string batch_id = 3;
	 */
	batchId?: string;

	/**
	 * Name of the code.
	 *
	 * @generated from field: string name = 4;
	 */
	name?: string;

	/**
	 * Description of the code.
	 *
	 * @generated from field: string description = 5;
	 */
	description?: string;

	/**
	 * Add a list of tags to the code.
	 *
	 * @generated from field: repeated string tags = 6;
	 */
	tags?: string[];

	/**
	 * Add a link suffix associated with the code.
	 *
	 * @generated from field: string link_suffix = 8;
	 */
	linkSuffix?: string;

	/**
	 * The link hash for the code's short URL.
	 *
	 * @generated from field: string link_hash = 11;
	 */
	linkHash?: string;

	/**
	 * Add data properties to the code.
	 *
	 * @generated from field: google.protobuf.Struct metadata = 7;
	 */
	metadata?: StructJson;

	/**
	 * Associate identity to the code.
	 *
	 * @generated from field: codes.v3.Identity identity = 23;
	 */
	identity?: IdentityJson;

	/**
	 * version of the batch
	 *
	 * @generated from field: optional string batch_version = 9;
	 */
	batchVersion?: string;

	/**
	 * @generated from field: codes.v3.GS1DigitalLinkData gs1_data = 10 [deprecated = true];
	 * @deprecated
	 */
	gs1Data?: GS1DigitalLinkDataJson;
};

/**
 * Describes the message codes.v3.AddCodeToBatchRequest.
 * Use `create(AddCodeToBatchRequestSchema)` to create a new message.
 */
export const AddCodeToBatchRequestSchema: GenMessage<AddCodeToBatchRequest, { jsonType: AddCodeToBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 21);

/**
 * @generated from message codes.v3.AddCodeToBatchResponse
 */
export type AddCodeToBatchResponse = Message<"codes.v3.AddCodeToBatchResponse"> & {
	/**
	 * Code that was added to the batch.
	 *
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: Code | undefined;
};

/**
 * @generated from message codes.v3.AddCodeToBatchResponse
 */
export type AddCodeToBatchResponseJson = {
	/**
	 * Code that was added to the batch.
	 *
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: CodeJson;
};

/**
 * Describes the message codes.v3.AddCodeToBatchResponse.
 * Use `create(AddCodeToBatchResponseSchema)` to create a new message.
 */
export const AddCodeToBatchResponseSchema: GenMessage<AddCodeToBatchResponse, { jsonType: AddCodeToBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 22);

/**
 * @generated from message codes.v3.AddCodesToBatchRequest
 */
export type AddCodesToBatchRequest = Message<"codes.v3.AddCodesToBatchRequest"> & {
	/**
	 * Org ID is the organization that the batch belongs to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * Workspace ID is the workspace that the batch belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * Batch ID is the batch that the codes will be added to.
	 *
	 * @generated from field: string batch_id = 3;
	 */
	batchId: string;

	/**
	 * List of requests for codes to add to the batch. Org, workspace, and batch id can be omitted in the individual requests.
	 *
	 * @generated from field: repeated codes.v3.AddCodeToBatchRequest requests = 4;
	 */
	requests: AddCodeToBatchRequest[];

	/**
	 * version of the batch
	 *
	 * @generated from field: optional string batch_version = 5;
	 */
	batchVersion?: string | undefined;
};

/**
 * @generated from message codes.v3.AddCodesToBatchRequest
 */
export type AddCodesToBatchRequestJson = {
	/**
	 * Org ID is the organization that the batch belongs to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * Workspace ID is the workspace that the batch belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * Batch ID is the batch that the codes will be added to.
	 *
	 * @generated from field: string batch_id = 3;
	 */
	batchId?: string;

	/**
	 * List of requests for codes to add to the batch. Org, workspace, and batch id can be omitted in the individual requests.
	 *
	 * @generated from field: repeated codes.v3.AddCodeToBatchRequest requests = 4;
	 */
	requests?: AddCodeToBatchRequestJson[];

	/**
	 * version of the batch
	 *
	 * @generated from field: optional string batch_version = 5;
	 */
	batchVersion?: string;
};

/**
 * Describes the message codes.v3.AddCodesToBatchRequest.
 * Use `create(AddCodesToBatchRequestSchema)` to create a new message.
 */
export const AddCodesToBatchRequestSchema: GenMessage<AddCodesToBatchRequest, { jsonType: AddCodesToBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 23);

/**
 * @generated from message codes.v3.AddCodesToBatchResponse
 */
export type AddCodesToBatchResponse = Message<"codes.v3.AddCodesToBatchResponse"> & {
	/**
	 * Codes that were added to the batch.
	 *
	 * @generated from field: repeated codes.v3.Code codes = 1;
	 */
	codes: Code[];
};

/**
 * @generated from message codes.v3.AddCodesToBatchResponse
 */
export type AddCodesToBatchResponseJson = {
	/**
	 * Codes that were added to the batch.
	 *
	 * @generated from field: repeated codes.v3.Code codes = 1;
	 */
	codes?: CodeJson[];
};

/**
 * Describes the message codes.v3.AddCodesToBatchResponse.
 * Use `create(AddCodesToBatchResponseSchema)` to create a new message.
 */
export const AddCodesToBatchResponseSchema: GenMessage<AddCodesToBatchResponse, { jsonType: AddCodesToBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 24);

/**
 * @generated from message codes.v3.UpsertCodesInBatchRequest
 */
export type UpsertCodesInBatchRequest = Message<"codes.v3.UpsertCodesInBatchRequest"> & {
	/**
	 * Org ID is the organization that the batch belongs to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * Workspace ID is the workspace that the batch belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * Batch ID is the batch that the codes will be added to.
	 *
	 * @generated from field: string batch_id = 3;
	 */
	batchId: string;

	/**
	 * List of requests for codes to add to the batch. Org, workspace, and batch id can be omitted in the individual requests.
	 *
	 * @generated from field: repeated codes.v3.AddCodeToBatchRequest requests = 4;
	 */
	requests: AddCodeToBatchRequest[];

	/**
	 * version of the batch
	 *
	 * @generated from field: optional string batch_version = 5;
	 */
	batchVersion?: string | undefined;
};

/**
 * @generated from message codes.v3.UpsertCodesInBatchRequest
 */
export type UpsertCodesInBatchRequestJson = {
	/**
	 * Org ID is the organization that the batch belongs to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * Workspace ID is the workspace that the batch belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * Batch ID is the batch that the codes will be added to.
	 *
	 * @generated from field: string batch_id = 3;
	 */
	batchId?: string;

	/**
	 * List of requests for codes to add to the batch. Org, workspace, and batch id can be omitted in the individual requests.
	 *
	 * @generated from field: repeated codes.v3.AddCodeToBatchRequest requests = 4;
	 */
	requests?: AddCodeToBatchRequestJson[];

	/**
	 * version of the batch
	 *
	 * @generated from field: optional string batch_version = 5;
	 */
	batchVersion?: string;
};

/**
 * Describes the message codes.v3.UpsertCodesInBatchRequest.
 * Use `create(UpsertCodesInBatchRequestSchema)` to create a new message.
 */
export const UpsertCodesInBatchRequestSchema: GenMessage<UpsertCodesInBatchRequest, { jsonType: UpsertCodesInBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 25);

/**
 * @generated from message codes.v3.UpsertCodesInBatchResponse
 */
export type UpsertCodesInBatchResponse = Message<"codes.v3.UpsertCodesInBatchResponse"> & {
	/**
	 * Codes that were created in the batch.
	 *
	 * @generated from field: repeated codes.v3.Code created = 1;
	 */
	created: Code[];

	/**
	 * Codes that were updated in the batch.
	 *
	 * @generated from field: repeated codes.v3.Code updated = 2;
	 */
	updated: Code[];
};

/**
 * @generated from message codes.v3.UpsertCodesInBatchResponse
 */
export type UpsertCodesInBatchResponseJson = {
	/**
	 * Codes that were created in the batch.
	 *
	 * @generated from field: repeated codes.v3.Code created = 1;
	 */
	created?: CodeJson[];

	/**
	 * Codes that were updated in the batch.
	 *
	 * @generated from field: repeated codes.v3.Code updated = 2;
	 */
	updated?: CodeJson[];
};

/**
 * Describes the message codes.v3.UpsertCodesInBatchResponse.
 * Use `create(UpsertCodesInBatchResponseSchema)` to create a new message.
 */
export const UpsertCodesInBatchResponseSchema: GenMessage<UpsertCodesInBatchResponse, { jsonType: UpsertCodesInBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 26);

/**
 * @generated from message codes.v3.UpdateCodesInBatchRequest
 */
export type UpdateCodesInBatchRequest = Message<"codes.v3.UpdateCodesInBatchRequest"> & {
	/**
	 * Org ID is the organization that the batch belongs to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * Workspace ID is the workspace that the batch belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * Batch ID is the batch that the codes belong to.
	 *
	 * @generated from field: string batch_id = 3;
	 */
	batchId: string;

	/**
	 * List of requests for codes to update within the batch. Valid fields to update are: name and metadata. Org, workspace, and batch id can be omitted in the individual requests.
	 *
	 * @generated from field: repeated codes.v3.UpdateCodeRequest requests = 4;
	 */
	requests: UpdateCodeRequest[];
};

/**
 * @generated from message codes.v3.UpdateCodesInBatchRequest
 */
export type UpdateCodesInBatchRequestJson = {
	/**
	 * Org ID is the organization that the batch belongs to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * Workspace ID is the workspace that the batch belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * Batch ID is the batch that the codes belong to.
	 *
	 * @generated from field: string batch_id = 3;
	 */
	batchId?: string;

	/**
	 * List of requests for codes to update within the batch. Valid fields to update are: name and metadata. Org, workspace, and batch id can be omitted in the individual requests.
	 *
	 * @generated from field: repeated codes.v3.UpdateCodeRequest requests = 4;
	 */
	requests?: UpdateCodeRequestJson[];
};

/**
 * Describes the message codes.v3.UpdateCodesInBatchRequest.
 * Use `create(UpdateCodesInBatchRequestSchema)` to create a new message.
 */
export const UpdateCodesInBatchRequestSchema: GenMessage<UpdateCodesInBatchRequest, { jsonType: UpdateCodesInBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 27);

/**
 * @generated from message codes.v3.UpdateCodesInBatchResponse
 */
export type UpdateCodesInBatchResponse = Message<"codes.v3.UpdateCodesInBatchResponse"> & {
	/**
	 * Codes that were updated in the batch.
	 *
	 * @generated from field: repeated codes.v3.Code codes = 1;
	 */
	codes: Code[];
};

/**
 * @generated from message codes.v3.UpdateCodesInBatchResponse
 */
export type UpdateCodesInBatchResponseJson = {
	/**
	 * Codes that were updated in the batch.
	 *
	 * @generated from field: repeated codes.v3.Code codes = 1;
	 */
	codes?: CodeJson[];
};

/**
 * Describes the message codes.v3.UpdateCodesInBatchResponse.
 * Use `create(UpdateCodesInBatchResponseSchema)` to create a new message.
 */
export const UpdateCodesInBatchResponseSchema: GenMessage<UpdateCodesInBatchResponse, { jsonType: UpdateCodesInBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 28);

/**
 * @generated from message codes.v3.BulkImportCodesRequest
 */
export type BulkImportCodesRequest = Message<"codes.v3.BulkImportCodesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string batch_id = 3;
	 */
	batchId: string;

	/**
	 * @generated from field: string file_url = 4;
	 */
	fileUrl: string;

	/**
	 * @generated from field: string audience_id = 9;
	 */
	audienceId: string;

	/**
	 * @generated from field: map<string, workflows.v1.MappedValue> mapping = 5;
	 */
	mapping: { [key: string]: MappedValue };

	/**
	 * @generated from field: bool has_header = 6;
	 */
	hasHeader: boolean;

	/**
	 * @generated from field: repeated string header = 7;
	 */
	header: string[];

	/**
	 * @generated from field: optional string batch_version = 8;
	 */
	batchVersion?: string | undefined;
};

/**
 * @generated from message codes.v3.BulkImportCodesRequest
 */
export type BulkImportCodesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string batch_id = 3;
	 */
	batchId?: string;

	/**
	 * @generated from field: string file_url = 4;
	 */
	fileUrl?: string;

	/**
	 * @generated from field: string audience_id = 9;
	 */
	audienceId?: string;

	/**
	 * @generated from field: map<string, workflows.v1.MappedValue> mapping = 5;
	 */
	mapping?: { [key: string]: MappedValueJson };

	/**
	 * @generated from field: bool has_header = 6;
	 */
	hasHeader?: boolean;

	/**
	 * @generated from field: repeated string header = 7;
	 */
	header?: string[];

	/**
	 * @generated from field: optional string batch_version = 8;
	 */
	batchVersion?: string;
};

/**
 * Describes the message codes.v3.BulkImportCodesRequest.
 * Use `create(BulkImportCodesRequestSchema)` to create a new message.
 */
export const BulkImportCodesRequestSchema: GenMessage<BulkImportCodesRequest, { jsonType: BulkImportCodesRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 29);

/**
 * @generated from message codes.v3.BulkImportCodesResponse
 */
export type BulkImportCodesResponse = Message<"codes.v3.BulkImportCodesResponse"> & {};

/**
 * @generated from message codes.v3.BulkImportCodesResponse
 */
export type BulkImportCodesResponseJson = {};

/**
 * Describes the message codes.v3.BulkImportCodesResponse.
 * Use `create(BulkImportCodesResponseSchema)` to create a new message.
 */
export const BulkImportCodesResponseSchema: GenMessage<BulkImportCodesResponse, { jsonType: BulkImportCodesResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 30);

/**
 * @generated from message codes.v3.ExportCodeRequest
 */
export type ExportCodeRequest = Message<"codes.v3.ExportCodeRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: codes.v3.OutputSink sink = 2;
	 */
	sink?: OutputSink | undefined;

	/**
	 * @generated from field: codes.v3.FileFormat format = 3;
	 */
	format: FileFormat;

	/**
	 * @generated from field: int32 dpi = 4;
	 */
	dpi: number;
};

/**
 * @generated from message codes.v3.ExportCodeRequest
 */
export type ExportCodeRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: codes.v3.OutputSink sink = 2;
	 */
	sink?: OutputSinkJson;

	/**
	 * @generated from field: codes.v3.FileFormat format = 3;
	 */
	format?: FileFormatJson;

	/**
	 * @generated from field: int32 dpi = 4;
	 */
	dpi?: number;
};

/**
 * Describes the message codes.v3.ExportCodeRequest.
 * Use `create(ExportCodeRequestSchema)` to create a new message.
 */
export const ExportCodeRequestSchema: GenMessage<ExportCodeRequest, { jsonType: ExportCodeRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 31);

/**
 * @generated from message codes.v3.ExportCodeResponse
 */
export type ExportCodeResponse = Message<"codes.v3.ExportCodeResponse"> & {
	/**
	 * @generated from field: string url = 1;
	 */
	url: string;
};

/**
 * @generated from message codes.v3.ExportCodeResponse
 */
export type ExportCodeResponseJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;
};

/**
 * Describes the message codes.v3.ExportCodeResponse.
 * Use `create(ExportCodeResponseSchema)` to create a new message.
 */
export const ExportCodeResponseSchema: GenMessage<ExportCodeResponse, { jsonType: ExportCodeResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 32);

/**
 * @generated from message codes.v3.BulkExportCodesRequest
 */
export type BulkExportCodesRequest = Message<"codes.v3.BulkExportCodesRequest"> & {
	/**
	 * @generated from field: codes.v3.ListCodesRequest req = 1;
	 */
	req?: ListCodesRequest | undefined;

	/**
	 * @generated from field: codes.v3.OutputSink sink = 2;
	 */
	sink?: OutputSink | undefined;

	/**
	 * @generated from field: codes.v3.FileFormat format = 3;
	 */
	format: FileFormat;

	/**
	 * @generated from field: int32 dpi = 4;
	 */
	dpi: number;

	/**
	 * @generated from field: repeated string email_recipients = 5;
	 */
	emailRecipients: string[];

	/**
	 * @generated from field: bool notify = 6;
	 */
	notify: boolean;
};

/**
 * @generated from message codes.v3.BulkExportCodesRequest
 */
export type BulkExportCodesRequestJson = {
	/**
	 * @generated from field: codes.v3.ListCodesRequest req = 1;
	 */
	req?: ListCodesRequestJson;

	/**
	 * @generated from field: codes.v3.OutputSink sink = 2;
	 */
	sink?: OutputSinkJson;

	/**
	 * @generated from field: codes.v3.FileFormat format = 3;
	 */
	format?: FileFormatJson;

	/**
	 * @generated from field: int32 dpi = 4;
	 */
	dpi?: number;

	/**
	 * @generated from field: repeated string email_recipients = 5;
	 */
	emailRecipients?: string[];

	/**
	 * @generated from field: bool notify = 6;
	 */
	notify?: boolean;
};

/**
 * Describes the message codes.v3.BulkExportCodesRequest.
 * Use `create(BulkExportCodesRequestSchema)` to create a new message.
 */
export const BulkExportCodesRequestSchema: GenMessage<BulkExportCodesRequest, { jsonType: BulkExportCodesRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 33);

/**
 * @generated from message codes.v3.BulkExportCodesResponse
 */
export type BulkExportCodesResponse = Message<"codes.v3.BulkExportCodesResponse"> & {
	/**
	 * @generated from field: string zip_url = 1;
	 */
	zipUrl: string;
};

/**
 * @generated from message codes.v3.BulkExportCodesResponse
 */
export type BulkExportCodesResponseJson = {
	/**
	 * @generated from field: string zip_url = 1;
	 */
	zipUrl?: string;
};

/**
 * Describes the message codes.v3.BulkExportCodesResponse.
 * Use `create(BulkExportCodesResponseSchema)` to create a new message.
 */
export const BulkExportCodesResponseSchema: GenMessage<BulkExportCodesResponse, { jsonType: BulkExportCodesResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 34);

/**
 * @generated from message codes.v3.ExportCodeMasksRequest
 */
export type ExportCodeMasksRequest = Message<"codes.v3.ExportCodeMasksRequest"> & {
	/**
	 * @generated from field: codes.v3.ListCodesRequest req = 1;
	 */
	req?: ListCodesRequest | undefined;

	/**
	 * @generated from field: codes.v3.OutputSink sink = 2;
	 */
	sink?: OutputSink | undefined;

	/**
	 * @generated from field: codes.v3.FileFormat format = 3;
	 */
	format: FileFormat;

	/**
	 * @generated from field: int32 dpi = 4;
	 */
	dpi: number;

	/**
	 * Page width in inches, applied to both mask layers so they stack at zero
	 * zero. This is the document size of the delivered file. Leave unset to keep
	 * the generator canvas size, which is what every export did before this field.
	 *
	 * @generated from field: optional double width_inches = 5;
	 */
	widthInches?: number | undefined;
};

/**
 * @generated from message codes.v3.ExportCodeMasksRequest
 */
export type ExportCodeMasksRequestJson = {
	/**
	 * @generated from field: codes.v3.ListCodesRequest req = 1;
	 */
	req?: ListCodesRequestJson;

	/**
	 * @generated from field: codes.v3.OutputSink sink = 2;
	 */
	sink?: OutputSinkJson;

	/**
	 * @generated from field: codes.v3.FileFormat format = 3;
	 */
	format?: FileFormatJson;

	/**
	 * @generated from field: int32 dpi = 4;
	 */
	dpi?: number;

	/**
	 * Page width in inches, applied to both mask layers so they stack at zero
	 * zero. This is the document size of the delivered file. Leave unset to keep
	 * the generator canvas size, which is what every export did before this field.
	 *
	 * @generated from field: optional double width_inches = 5;
	 */
	widthInches?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message codes.v3.ExportCodeMasksRequest.
 * Use `create(ExportCodeMasksRequestSchema)` to create a new message.
 */
export const ExportCodeMasksRequestSchema: GenMessage<ExportCodeMasksRequest, { jsonType: ExportCodeMasksRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 35);

/**
 * @generated from message codes.v3.ExportCodeMasksResponse
 */
export type ExportCodeMasksResponse = Message<"codes.v3.ExportCodeMasksResponse"> & {
	/**
	 * @generated from field: string zip_url = 1;
	 */
	zipUrl: string;
};

/**
 * @generated from message codes.v3.ExportCodeMasksResponse
 */
export type ExportCodeMasksResponseJson = {
	/**
	 * @generated from field: string zip_url = 1;
	 */
	zipUrl?: string;
};

/**
 * Describes the message codes.v3.ExportCodeMasksResponse.
 * Use `create(ExportCodeMasksResponseSchema)` to create a new message.
 */
export const ExportCodeMasksResponseSchema: GenMessage<ExportCodeMasksResponse, { jsonType: ExportCodeMasksResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 36);

/**
 * @generated from message codes.v3.S3Bucket
 */
export type S3Bucket = Message<"codes.v3.S3Bucket"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: string directory = 2;
	 */
	directory: string;
};

/**
 * @generated from message codes.v3.S3Bucket
 */
export type S3BucketJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string directory = 2;
	 */
	directory?: string;
};

/**
 * Describes the message codes.v3.S3Bucket.
 * Use `create(S3BucketSchema)` to create a new message.
 */
export const S3BucketSchema: GenMessage<S3Bucket, { jsonType: S3BucketJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 37);

/**
 * @generated from message codes.v3.OutputSink
 */
export type OutputSink = Message<"codes.v3.OutputSink"> & {
	/**
	 * @generated from oneof codes.v3.OutputSink.location
	 */
	location:
		| {
				/**
				 * @generated from field: codes.v3.S3Bucket bucket = 1;
				 */
				value: S3Bucket;
				case: "bucket";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message codes.v3.OutputSink
 */
export type OutputSinkJson = {
	/**
	 * @generated from field: codes.v3.S3Bucket bucket = 1;
	 */
	bucket?: S3BucketJson;
};

/**
 * Describes the message codes.v3.OutputSink.
 * Use `create(OutputSinkSchema)` to create a new message.
 */
export const OutputSinkSchema: GenMessage<OutputSink, { jsonType: OutputSinkJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 38);

/**
 * @generated from message codes.v3.Batch
 */
export type Batch = Message<"codes.v3.Batch"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 20;
	 */
	version: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: optional string brand_kit_id = 7;
	 */
	brandKitId?: string | undefined;

	/**
	 * @generated from field: optional string domain_id = 8;
	 */
	domainId?: string | undefined;

	/**
	 * @generated from field: optional string domain = 18;
	 */
	domain?: string | undefined;

	/**
	 * @generated from field: string state = 9;
	 */
	state: string;

	/**
	 * @generated from field: string folder_path = 10;
	 */
	folderPath: string;

	/**
	 * @generated from field: repeated string tags = 11;
	 */
	tags: string[];

	/**
	 * @generated from field: codes.v3.Destination base_destination = 12;
	 */
	baseDestination?: Destination | undefined;

	/**
	 * @generated from field: string link_suffix = 19;
	 */
	linkSuffix: string;

	/**
	 * @generated from field: codes.v3.CodeDesign base_design = 13;
	 */
	baseDesign?: CodeDesign | undefined;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 14;
	 */
	metadata?: JsonObject | undefined;

	/**
	 * @generated from field: string metadata_schema = 17;
	 */
	metadataSchema: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 15;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 16;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: codes.v3.BatchType batch_type = 21;
	 */
	batchType: BatchType;
};

/**
 * @generated from message codes.v3.Batch
 */
export type BatchJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 20;
	 */
	version?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: optional string brand_kit_id = 7;
	 */
	brandKitId?: string;

	/**
	 * @generated from field: optional string domain_id = 8;
	 */
	domainId?: string;

	/**
	 * @generated from field: optional string domain = 18;
	 */
	domain?: string;

	/**
	 * @generated from field: string state = 9;
	 */
	state?: string;

	/**
	 * @generated from field: string folder_path = 10;
	 */
	folderPath?: string;

	/**
	 * @generated from field: repeated string tags = 11;
	 */
	tags?: string[];

	/**
	 * @generated from field: codes.v3.Destination base_destination = 12;
	 */
	baseDestination?: DestinationJson;

	/**
	 * @generated from field: string link_suffix = 19;
	 */
	linkSuffix?: string;

	/**
	 * @generated from field: codes.v3.CodeDesign base_design = 13;
	 */
	baseDesign?: CodeDesignJson;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 14;
	 */
	metadata?: StructJson;

	/**
	 * @generated from field: string metadata_schema = 17;
	 */
	metadataSchema?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 15;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 16;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: codes.v3.BatchType batch_type = 21;
	 */
	batchType?: BatchTypeJson;
};

/**
 * Describes the message codes.v3.Batch.
 * Use `create(BatchSchema)` to create a new message.
 */
export const BatchSchema: GenMessage<Batch, { jsonType: BatchJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 39);

/**
 * @generated from message codes.v3.CreateBatchRequest
 */
export type CreateBatchRequest = Message<"codes.v3.CreateBatchRequest"> & {
	/**
	 * @generated from field: codes.v3.Batch batch = 1;
	 */
	batch?: Batch | undefined;
};

/**
 * @generated from message codes.v3.CreateBatchRequest
 */
export type CreateBatchRequestJson = {
	/**
	 * @generated from field: codes.v3.Batch batch = 1;
	 */
	batch?: BatchJson;
};

/**
 * Describes the message codes.v3.CreateBatchRequest.
 * Use `create(CreateBatchRequestSchema)` to create a new message.
 */
export const CreateBatchRequestSchema: GenMessage<CreateBatchRequest, { jsonType: CreateBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 40);

/**
 * @generated from message codes.v3.CreateBatchResponse
 */
export type CreateBatchResponse = Message<"codes.v3.CreateBatchResponse"> & {
	/**
	 * @generated from field: codes.v3.Batch batch = 1;
	 */
	batch?: Batch | undefined;
};

/**
 * @generated from message codes.v3.CreateBatchResponse
 */
export type CreateBatchResponseJson = {
	/**
	 * @generated from field: codes.v3.Batch batch = 1;
	 */
	batch?: BatchJson;
};

/**
 * Describes the message codes.v3.CreateBatchResponse.
 * Use `create(CreateBatchResponseSchema)` to create a new message.
 */
export const CreateBatchResponseSchema: GenMessage<CreateBatchResponse, { jsonType: CreateBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 41);

/**
 * @generated from message codes.v3.CreateBatchFromTemplateRequest
 */
export type CreateBatchFromTemplateRequest = Message<"codes.v3.CreateBatchFromTemplateRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string template_id = 3;
	 */
	templateId: string;

	/**
	 * @generated from field: string template_version = 13;
	 */
	templateVersion: string;

	/**
	 * @generated from field: optional string brand_kit_id = 4;
	 */
	brandKitId?: string | undefined;

	/**
	 * @generated from field: optional string domain_id = 5;
	 */
	domainId?: string | undefined;

	/**
	 * @generated from field: string folder_path = 6;
	 */
	folderPath: string;

	/**
	 * @generated from field: string name = 7;
	 */
	name: string;

	/**
	 * @generated from field: string description = 8;
	 */
	description: string;

	/**
	 * @generated from field: repeated string tags = 9;
	 */
	tags: string[];

	/**
	 * @generated from field: codes.v3.Destination base_destination = 10;
	 */
	baseDestination?: Destination | undefined;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 11;
	 */
	metadata?: JsonObject | undefined;

	/**
	 * @generated from field: string metadata_schema = 12;
	 */
	metadataSchema: string;
};

/**
 * @generated from message codes.v3.CreateBatchFromTemplateRequest
 */
export type CreateBatchFromTemplateRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string template_id = 3;
	 */
	templateId?: string;

	/**
	 * @generated from field: string template_version = 13;
	 */
	templateVersion?: string;

	/**
	 * @generated from field: optional string brand_kit_id = 4;
	 */
	brandKitId?: string;

	/**
	 * @generated from field: optional string domain_id = 5;
	 */
	domainId?: string;

	/**
	 * @generated from field: string folder_path = 6;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string name = 7;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 8;
	 */
	description?: string;

	/**
	 * @generated from field: repeated string tags = 9;
	 */
	tags?: string[];

	/**
	 * @generated from field: codes.v3.Destination base_destination = 10;
	 */
	baseDestination?: DestinationJson;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 11;
	 */
	metadata?: StructJson;

	/**
	 * @generated from field: string metadata_schema = 12;
	 */
	metadataSchema?: string;
};

/**
 * Describes the message codes.v3.CreateBatchFromTemplateRequest.
 * Use `create(CreateBatchFromTemplateRequestSchema)` to create a new message.
 */
export const CreateBatchFromTemplateRequestSchema: GenMessage<CreateBatchFromTemplateRequest, { jsonType: CreateBatchFromTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 42);

/**
 * @generated from message codes.v3.CreateBatchFromTemplateResponse
 */
export type CreateBatchFromTemplateResponse = Message<"codes.v3.CreateBatchFromTemplateResponse"> & {
	/**
	 * @generated from field: codes.v3.Batch batch = 1;
	 */
	batch?: Batch | undefined;
};

/**
 * @generated from message codes.v3.CreateBatchFromTemplateResponse
 */
export type CreateBatchFromTemplateResponseJson = {
	/**
	 * @generated from field: codes.v3.Batch batch = 1;
	 */
	batch?: BatchJson;
};

/**
 * Describes the message codes.v3.CreateBatchFromTemplateResponse.
 * Use `create(CreateBatchFromTemplateResponseSchema)` to create a new message.
 */
export const CreateBatchFromTemplateResponseSchema: GenMessage<CreateBatchFromTemplateResponse, { jsonType: CreateBatchFromTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 43);

/**
 * @generated from message codes.v3.ListBatchesRequest
 */
export type ListBatchesRequest = Message<"codes.v3.ListBatchesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string | undefined;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId: string;

	/**
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags: string[];

	/**
	 * @generated from field: repeated string states = 8;
	 */
	states: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message codes.v3.ListBatchesRequest
 */
export type ListBatchesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId?: string;

	/**
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix?: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags?: string[];

	/**
	 * @generated from field: repeated string states = 8;
	 */
	states?: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message codes.v3.ListBatchesRequest.
 * Use `create(ListBatchesRequestSchema)` to create a new message.
 */
export const ListBatchesRequestSchema: GenMessage<ListBatchesRequest, { jsonType: ListBatchesRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 44);

/**
 * @generated from message codes.v3.ListBatchesResponse
 */
export type ListBatchesResponse = Message<"codes.v3.ListBatchesResponse"> & {
	/**
	 * @generated from field: repeated codes.v3.Batch batches = 1;
	 */
	batches: Batch[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message codes.v3.ListBatchesResponse
 */
export type ListBatchesResponseJson = {
	/**
	 * @generated from field: repeated codes.v3.Batch batches = 1;
	 */
	batches?: BatchJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message codes.v3.ListBatchesResponse.
 * Use `create(ListBatchesResponseSchema)` to create a new message.
 */
export const ListBatchesResponseSchema: GenMessage<ListBatchesResponse, { jsonType: ListBatchesResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 45);

/**
 * @generated from message codes.v3.GetBatchRequest
 */
export type GetBatchRequest = Message<"codes.v3.GetBatchRequest"> & {
	/**
	 * ID of the batch.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message codes.v3.GetBatchRequest
 */
export type GetBatchRequestJson = {
	/**
	 * ID of the batch.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message codes.v3.GetBatchRequest.
 * Use `create(GetBatchRequestSchema)` to create a new message.
 */
export const GetBatchRequestSchema: GenMessage<GetBatchRequest, { jsonType: GetBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 46);

/**
 * @generated from message codes.v3.GetBatchResponse
 */
export type GetBatchResponse = Message<"codes.v3.GetBatchResponse"> & {
	/**
	 * Batch that matched the query.
	 *
	 * @generated from field: codes.v3.Batch batch = 1;
	 */
	batch?: Batch | undefined;
};

/**
 * @generated from message codes.v3.GetBatchResponse
 */
export type GetBatchResponseJson = {
	/**
	 * Batch that matched the query.
	 *
	 * @generated from field: codes.v3.Batch batch = 1;
	 */
	batch?: BatchJson;
};

/**
 * Describes the message codes.v3.GetBatchResponse.
 * Use `create(GetBatchResponseSchema)` to create a new message.
 */
export const GetBatchResponseSchema: GenMessage<GetBatchResponse, { jsonType: GetBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 47);

/**
 * @generated from message codes.v3.UpdateBatchRequest
 */
export type UpdateBatchRequest = Message<"codes.v3.UpdateBatchRequest"> & {
	/**
	 * @generated from field: codes.v3.Batch batch = 1;
	 */
	batch?: Batch | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message codes.v3.UpdateBatchRequest
 */
export type UpdateBatchRequestJson = {
	/**
	 * @generated from field: codes.v3.Batch batch = 1;
	 */
	batch?: BatchJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message codes.v3.UpdateBatchRequest.
 * Use `create(UpdateBatchRequestSchema)` to create a new message.
 */
export const UpdateBatchRequestSchema: GenMessage<UpdateBatchRequest, { jsonType: UpdateBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 48);

/**
 * @generated from message codes.v3.UpdateBatchResponse
 */
export type UpdateBatchResponse = Message<"codes.v3.UpdateBatchResponse"> & {
	/**
	 * @generated from field: codes.v3.Batch batch = 1;
	 */
	batch?: Batch | undefined;
};

/**
 * @generated from message codes.v3.UpdateBatchResponse
 */
export type UpdateBatchResponseJson = {
	/**
	 * @generated from field: codes.v3.Batch batch = 1;
	 */
	batch?: BatchJson;
};

/**
 * Describes the message codes.v3.UpdateBatchResponse.
 * Use `create(UpdateBatchResponseSchema)` to create a new message.
 */
export const UpdateBatchResponseSchema: GenMessage<UpdateBatchResponse, { jsonType: UpdateBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 49);

/**
 * @generated from message codes.v3.DeleteBatchRequest
 */
export type DeleteBatchRequest = Message<"codes.v3.DeleteBatchRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message codes.v3.DeleteBatchRequest
 */
export type DeleteBatchRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message codes.v3.DeleteBatchRequest.
 * Use `create(DeleteBatchRequestSchema)` to create a new message.
 */
export const DeleteBatchRequestSchema: GenMessage<DeleteBatchRequest, { jsonType: DeleteBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 50);

/**
 * @generated from message codes.v3.DeleteBatchResponse
 */
export type DeleteBatchResponse = Message<"codes.v3.DeleteBatchResponse"> & {};

/**
 * @generated from message codes.v3.DeleteBatchResponse
 */
export type DeleteBatchResponseJson = {};

/**
 * Describes the message codes.v3.DeleteBatchResponse.
 * Use `create(DeleteBatchResponseSchema)` to create a new message.
 */
export const DeleteBatchResponseSchema: GenMessage<DeleteBatchResponse, { jsonType: DeleteBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 51);

/**
 * @generated from message codes.v3.DeleteCodesInBatchRequest
 */
export type DeleteCodesInBatchRequest = Message<"codes.v3.DeleteCodesInBatchRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message codes.v3.DeleteCodesInBatchRequest
 */
export type DeleteCodesInBatchRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message codes.v3.DeleteCodesInBatchRequest.
 * Use `create(DeleteCodesInBatchRequestSchema)` to create a new message.
 */
export const DeleteCodesInBatchRequestSchema: GenMessage<DeleteCodesInBatchRequest, { jsonType: DeleteCodesInBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 52);

/**
 * @generated from message codes.v3.DeleteCodesInBatchResponse
 */
export type DeleteCodesInBatchResponse = Message<"codes.v3.DeleteCodesInBatchResponse"> & {};

/**
 * @generated from message codes.v3.DeleteCodesInBatchResponse
 */
export type DeleteCodesInBatchResponseJson = {};

/**
 * Describes the message codes.v3.DeleteCodesInBatchResponse.
 * Use `create(DeleteCodesInBatchResponseSchema)` to create a new message.
 */
export const DeleteCodesInBatchResponseSchema: GenMessage<DeleteCodesInBatchResponse, { jsonType: DeleteCodesInBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 53);

/**
 *
 * Batch Templates
 *
 * @generated from message codes.v3.BatchTemplate
 */
export type BatchTemplate = Message<"codes.v3.BatchTemplate"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 17;
	 */
	version: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: optional string brand_kit_id = 7;
	 */
	brandKitId?: string | undefined;

	/**
	 * @generated from field: optional string domain_id = 8;
	 */
	domainId?: string | undefined;

	/**
	 * @generated from field: string state = 9;
	 */
	state: string;

	/**
	 * @generated from field: string visibility = 16;
	 */
	visibility: string;

	/**
	 * @generated from field: string folder_path = 10;
	 */
	folderPath: string;

	/**
	 * @generated from field: repeated string tags = 11;
	 */
	tags: string[];

	/**
	 * @generated from field: codes.v3.CodeDesign base_design = 12;
	 */
	baseDesign?: CodeDesign | undefined;

	/**
	 * @generated from field: string metadata_schema = 15;
	 */
	metadataSchema: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 13;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 14;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: codes.v3.BatchType batch_type = 18;
	 */
	batchType: BatchType;
};

/**
 *
 * Batch Templates
 *
 * @generated from message codes.v3.BatchTemplate
 */
export type BatchTemplateJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 17;
	 */
	version?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: optional string brand_kit_id = 7;
	 */
	brandKitId?: string;

	/**
	 * @generated from field: optional string domain_id = 8;
	 */
	domainId?: string;

	/**
	 * @generated from field: string state = 9;
	 */
	state?: string;

	/**
	 * @generated from field: string visibility = 16;
	 */
	visibility?: string;

	/**
	 * @generated from field: string folder_path = 10;
	 */
	folderPath?: string;

	/**
	 * @generated from field: repeated string tags = 11;
	 */
	tags?: string[];

	/**
	 * @generated from field: codes.v3.CodeDesign base_design = 12;
	 */
	baseDesign?: CodeDesignJson;

	/**
	 * @generated from field: string metadata_schema = 15;
	 */
	metadataSchema?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 13;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 14;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: codes.v3.BatchType batch_type = 18;
	 */
	batchType?: BatchTypeJson;
};

/**
 * Describes the message codes.v3.BatchTemplate.
 * Use `create(BatchTemplateSchema)` to create a new message.
 */
export const BatchTemplateSchema: GenMessage<BatchTemplate, { jsonType: BatchTemplateJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 54);

/**
 * @generated from message codes.v3.CreateBatchTemplateRequest
 */
export type CreateBatchTemplateRequest = Message<"codes.v3.CreateBatchTemplateRequest"> & {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplate | undefined;
};

/**
 * @generated from message codes.v3.CreateBatchTemplateRequest
 */
export type CreateBatchTemplateRequestJson = {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplateJson;
};

/**
 * Describes the message codes.v3.CreateBatchTemplateRequest.
 * Use `create(CreateBatchTemplateRequestSchema)` to create a new message.
 */
export const CreateBatchTemplateRequestSchema: GenMessage<CreateBatchTemplateRequest, { jsonType: CreateBatchTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 55);

/**
 * @generated from message codes.v3.CreateBatchTemplateResponse
 */
export type CreateBatchTemplateResponse = Message<"codes.v3.CreateBatchTemplateResponse"> & {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplate | undefined;
};

/**
 * @generated from message codes.v3.CreateBatchTemplateResponse
 */
export type CreateBatchTemplateResponseJson = {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplateJson;
};

/**
 * Describes the message codes.v3.CreateBatchTemplateResponse.
 * Use `create(CreateBatchTemplateResponseSchema)` to create a new message.
 */
export const CreateBatchTemplateResponseSchema: GenMessage<CreateBatchTemplateResponse, { jsonType: CreateBatchTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 56);

/**
 * @generated from message codes.v3.CreateBatchTemplateVersionRequest
 */
export type CreateBatchTemplateVersionRequest = Message<"codes.v3.CreateBatchTemplateVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2 [deprecated = true];
	 * @deprecated
	 */
	version: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 4;
	 */
	increment: VersionIncrement;

	/**
	 * @generated from field: string base_version = 3;
	 */
	baseVersion: string;
};

/**
 * @generated from message codes.v3.CreateBatchTemplateVersionRequest
 */
export type CreateBatchTemplateVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2 [deprecated = true];
	 * @deprecated
	 */
	version?: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 4;
	 */
	increment?: VersionIncrementJson;

	/**
	 * @generated from field: string base_version = 3;
	 */
	baseVersion?: string;
};

/**
 * Describes the message codes.v3.CreateBatchTemplateVersionRequest.
 * Use `create(CreateBatchTemplateVersionRequestSchema)` to create a new message.
 */
export const CreateBatchTemplateVersionRequestSchema: GenMessage<CreateBatchTemplateVersionRequest, { jsonType: CreateBatchTemplateVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 57);

/**
 * @generated from message codes.v3.CreateBatchTemplateVersionResponse
 */
export type CreateBatchTemplateVersionResponse = Message<"codes.v3.CreateBatchTemplateVersionResponse"> & {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplate | undefined;
};

/**
 * @generated from message codes.v3.CreateBatchTemplateVersionResponse
 */
export type CreateBatchTemplateVersionResponseJson = {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplateJson;
};

/**
 * Describes the message codes.v3.CreateBatchTemplateVersionResponse.
 * Use `create(CreateBatchTemplateVersionResponseSchema)` to create a new message.
 */
export const CreateBatchTemplateVersionResponseSchema: GenMessage<CreateBatchTemplateVersionResponse, { jsonType: CreateBatchTemplateVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 58);

/**
 * @generated from message codes.v3.PublishBatchTemplateVersionRequest
 */
export type PublishBatchTemplateVersionRequest = Message<"codes.v3.PublishBatchTemplateVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: string visibility = 3;
	 */
	visibility: string;
};

/**
 * @generated from message codes.v3.PublishBatchTemplateVersionRequest
 */
export type PublishBatchTemplateVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: string visibility = 3;
	 */
	visibility?: string;
};

/**
 * Describes the message codes.v3.PublishBatchTemplateVersionRequest.
 * Use `create(PublishBatchTemplateVersionRequestSchema)` to create a new message.
 */
export const PublishBatchTemplateVersionRequestSchema: GenMessage<PublishBatchTemplateVersionRequest, { jsonType: PublishBatchTemplateVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 59);

/**
 * @generated from message codes.v3.PublishBatchTemplateVersionResponse
 */
export type PublishBatchTemplateVersionResponse = Message<"codes.v3.PublishBatchTemplateVersionResponse"> & {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplate | undefined;
};

/**
 * @generated from message codes.v3.PublishBatchTemplateVersionResponse
 */
export type PublishBatchTemplateVersionResponseJson = {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplateJson;
};

/**
 * Describes the message codes.v3.PublishBatchTemplateVersionResponse.
 * Use `create(PublishBatchTemplateVersionResponseSchema)` to create a new message.
 */
export const PublishBatchTemplateVersionResponseSchema: GenMessage<PublishBatchTemplateVersionResponse, { jsonType: PublishBatchTemplateVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 60);

/**
 * @generated from message codes.v3.ListBatchTemplatesRequest
 */
export type ListBatchTemplatesRequest = Message<"codes.v3.ListBatchTemplatesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string | undefined;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId: string;

	/**
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message codes.v3.ListBatchTemplatesRequest
 */
export type ListBatchTemplatesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId?: string;

	/**
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix?: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags?: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message codes.v3.ListBatchTemplatesRequest.
 * Use `create(ListBatchTemplatesRequestSchema)` to create a new message.
 */
export const ListBatchTemplatesRequestSchema: GenMessage<ListBatchTemplatesRequest, { jsonType: ListBatchTemplatesRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 61);

/**
 * @generated from message codes.v3.ListBatchTemplatesResponse
 */
export type ListBatchTemplatesResponse = Message<"codes.v3.ListBatchTemplatesResponse"> & {
	/**
	 * @generated from field: repeated codes.v3.BatchTemplate templates = 1;
	 */
	templates: BatchTemplate[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message codes.v3.ListBatchTemplatesResponse
 */
export type ListBatchTemplatesResponseJson = {
	/**
	 * @generated from field: repeated codes.v3.BatchTemplate templates = 1;
	 */
	templates?: BatchTemplateJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message codes.v3.ListBatchTemplatesResponse.
 * Use `create(ListBatchTemplatesResponseSchema)` to create a new message.
 */
export const ListBatchTemplatesResponseSchema: GenMessage<ListBatchTemplatesResponse, { jsonType: ListBatchTemplatesResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 62);

/**
 * @generated from message codes.v3.GetBatchTemplateRequest
 */
export type GetBatchTemplateRequest = Message<"codes.v3.GetBatchTemplateRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message codes.v3.GetBatchTemplateRequest
 */
export type GetBatchTemplateRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message codes.v3.GetBatchTemplateRequest.
 * Use `create(GetBatchTemplateRequestSchema)` to create a new message.
 */
export const GetBatchTemplateRequestSchema: GenMessage<GetBatchTemplateRequest, { jsonType: GetBatchTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 63);

/**
 * @generated from message codes.v3.GetBatchTemplateResponse
 */
export type GetBatchTemplateResponse = Message<"codes.v3.GetBatchTemplateResponse"> & {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplate | undefined;
};

/**
 * @generated from message codes.v3.GetBatchTemplateResponse
 */
export type GetBatchTemplateResponseJson = {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplateJson;
};

/**
 * Describes the message codes.v3.GetBatchTemplateResponse.
 * Use `create(GetBatchTemplateResponseSchema)` to create a new message.
 */
export const GetBatchTemplateResponseSchema: GenMessage<GetBatchTemplateResponse, { jsonType: GetBatchTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 64);

/**
 * @generated from message codes.v3.UpdateBatchTemplateRequest
 */
export type UpdateBatchTemplateRequest = Message<"codes.v3.UpdateBatchTemplateRequest"> & {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplate | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message codes.v3.UpdateBatchTemplateRequest
 */
export type UpdateBatchTemplateRequestJson = {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplateJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message codes.v3.UpdateBatchTemplateRequest.
 * Use `create(UpdateBatchTemplateRequestSchema)` to create a new message.
 */
export const UpdateBatchTemplateRequestSchema: GenMessage<UpdateBatchTemplateRequest, { jsonType: UpdateBatchTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 65);

/**
 * @generated from message codes.v3.UpdateBatchTemplateResponse
 */
export type UpdateBatchTemplateResponse = Message<"codes.v3.UpdateBatchTemplateResponse"> & {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplate | undefined;
};

/**
 * @generated from message codes.v3.UpdateBatchTemplateResponse
 */
export type UpdateBatchTemplateResponseJson = {
	/**
	 * @generated from field: codes.v3.BatchTemplate template = 1;
	 */
	template?: BatchTemplateJson;
};

/**
 * Describes the message codes.v3.UpdateBatchTemplateResponse.
 * Use `create(UpdateBatchTemplateResponseSchema)` to create a new message.
 */
export const UpdateBatchTemplateResponseSchema: GenMessage<UpdateBatchTemplateResponse, { jsonType: UpdateBatchTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 66);

/**
 * @generated from message codes.v3.DeleteBatchTemplateRequest
 */
export type DeleteBatchTemplateRequest = Message<"codes.v3.DeleteBatchTemplateRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message codes.v3.DeleteBatchTemplateRequest
 */
export type DeleteBatchTemplateRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message codes.v3.DeleteBatchTemplateRequest.
 * Use `create(DeleteBatchTemplateRequestSchema)` to create a new message.
 */
export const DeleteBatchTemplateRequestSchema: GenMessage<DeleteBatchTemplateRequest, { jsonType: DeleteBatchTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 67);

/**
 * @generated from message codes.v3.DeleteBatchTemplateResponse
 */
export type DeleteBatchTemplateResponse = Message<"codes.v3.DeleteBatchTemplateResponse"> & {};

/**
 * @generated from message codes.v3.DeleteBatchTemplateResponse
 */
export type DeleteBatchTemplateResponseJson = {};

/**
 * Describes the message codes.v3.DeleteBatchTemplateResponse.
 * Use `create(DeleteBatchTemplateResponseSchema)` to create a new message.
 */
export const DeleteBatchTemplateResponseSchema: GenMessage<DeleteBatchTemplateResponse, { jsonType: DeleteBatchTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 68);

/**
 *
 * Studio Configs
 *
 * @generated from message codes.v3.StudioConfig
 */
export type StudioConfig = Message<"codes.v3.StudioConfig"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 14;
	 */
	version: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: string state = 7;
	 */
	state: string;

	/**
	 * @generated from field: string visibility = 13;
	 */
	visibility: string;

	/**
	 * @generated from field: string folder_path = 8;
	 */
	folderPath: string;

	/**
	 * @generated from field: repeated string tags = 9;
	 */
	tags: string[];

	/**
	 * @generated from field: google.protobuf.Struct config = 10;
	 */
	config?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 12;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 *
 * Studio Configs
 *
 * @generated from message codes.v3.StudioConfig
 */
export type StudioConfigJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 14;
	 */
	version?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: string state = 7;
	 */
	state?: string;

	/**
	 * @generated from field: string visibility = 13;
	 */
	visibility?: string;

	/**
	 * @generated from field: string folder_path = 8;
	 */
	folderPath?: string;

	/**
	 * @generated from field: repeated string tags = 9;
	 */
	tags?: string[];

	/**
	 * @generated from field: google.protobuf.Struct config = 10;
	 */
	config?: StructJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 12;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message codes.v3.StudioConfig.
 * Use `create(StudioConfigSchema)` to create a new message.
 */
export const StudioConfigSchema: GenMessage<StudioConfig, { jsonType: StudioConfigJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 69);

/**
 * @generated from message codes.v3.CreateStudioConfigRequest
 */
export type CreateStudioConfigRequest = Message<"codes.v3.CreateStudioConfigRequest"> & {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfig | undefined;
};

/**
 * @generated from message codes.v3.CreateStudioConfigRequest
 */
export type CreateStudioConfigRequestJson = {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfigJson;
};

/**
 * Describes the message codes.v3.CreateStudioConfigRequest.
 * Use `create(CreateStudioConfigRequestSchema)` to create a new message.
 */
export const CreateStudioConfigRequestSchema: GenMessage<CreateStudioConfigRequest, { jsonType: CreateStudioConfigRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 70);

/**
 * @generated from message codes.v3.CreateStudioConfigResponse
 */
export type CreateStudioConfigResponse = Message<"codes.v3.CreateStudioConfigResponse"> & {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfig | undefined;
};

/**
 * @generated from message codes.v3.CreateStudioConfigResponse
 */
export type CreateStudioConfigResponseJson = {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfigJson;
};

/**
 * Describes the message codes.v3.CreateStudioConfigResponse.
 * Use `create(CreateStudioConfigResponseSchema)` to create a new message.
 */
export const CreateStudioConfigResponseSchema: GenMessage<CreateStudioConfigResponse, { jsonType: CreateStudioConfigResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 71);

/**
 * @generated from message codes.v3.GetStudioConfigRequest
 */
export type GetStudioConfigRequest = Message<"codes.v3.GetStudioConfigRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message codes.v3.GetStudioConfigRequest
 */
export type GetStudioConfigRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message codes.v3.GetStudioConfigRequest.
 * Use `create(GetStudioConfigRequestSchema)` to create a new message.
 */
export const GetStudioConfigRequestSchema: GenMessage<GetStudioConfigRequest, { jsonType: GetStudioConfigRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 72);

/**
 * @generated from message codes.v3.GetStudioConfigResponse
 */
export type GetStudioConfigResponse = Message<"codes.v3.GetStudioConfigResponse"> & {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfig | undefined;
};

/**
 * @generated from message codes.v3.GetStudioConfigResponse
 */
export type GetStudioConfigResponseJson = {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfigJson;
};

/**
 * Describes the message codes.v3.GetStudioConfigResponse.
 * Use `create(GetStudioConfigResponseSchema)` to create a new message.
 */
export const GetStudioConfigResponseSchema: GenMessage<GetStudioConfigResponse, { jsonType: GetStudioConfigResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 73);

/**
 * @generated from message codes.v3.CreateStudioConfigVersionRequest
 */
export type CreateStudioConfigVersionRequest = Message<"codes.v3.CreateStudioConfigVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2 [deprecated = true];
	 * @deprecated
	 */
	version: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 4;
	 */
	increment: VersionIncrement;

	/**
	 * @generated from field: string base_version = 3;
	 */
	baseVersion: string;
};

/**
 * @generated from message codes.v3.CreateStudioConfigVersionRequest
 */
export type CreateStudioConfigVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2 [deprecated = true];
	 * @deprecated
	 */
	version?: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 4;
	 */
	increment?: VersionIncrementJson;

	/**
	 * @generated from field: string base_version = 3;
	 */
	baseVersion?: string;
};

/**
 * Describes the message codes.v3.CreateStudioConfigVersionRequest.
 * Use `create(CreateStudioConfigVersionRequestSchema)` to create a new message.
 */
export const CreateStudioConfigVersionRequestSchema: GenMessage<CreateStudioConfigVersionRequest, { jsonType: CreateStudioConfigVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 74);

/**
 * @generated from message codes.v3.CreateStudioConfigVersionResponse
 */
export type CreateStudioConfigVersionResponse = Message<"codes.v3.CreateStudioConfigVersionResponse"> & {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfig | undefined;
};

/**
 * @generated from message codes.v3.CreateStudioConfigVersionResponse
 */
export type CreateStudioConfigVersionResponseJson = {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfigJson;
};

/**
 * Describes the message codes.v3.CreateStudioConfigVersionResponse.
 * Use `create(CreateStudioConfigVersionResponseSchema)` to create a new message.
 */
export const CreateStudioConfigVersionResponseSchema: GenMessage<CreateStudioConfigVersionResponse, { jsonType: CreateStudioConfigVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 75);

/**
 * @generated from message codes.v3.PublishStudioConfigVersionRequest
 */
export type PublishStudioConfigVersionRequest = Message<"codes.v3.PublishStudioConfigVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: string visibility = 3;
	 */
	visibility: string;
};

/**
 * @generated from message codes.v3.PublishStudioConfigVersionRequest
 */
export type PublishStudioConfigVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: string visibility = 3;
	 */
	visibility?: string;
};

/**
 * Describes the message codes.v3.PublishStudioConfigVersionRequest.
 * Use `create(PublishStudioConfigVersionRequestSchema)` to create a new message.
 */
export const PublishStudioConfigVersionRequestSchema: GenMessage<PublishStudioConfigVersionRequest, { jsonType: PublishStudioConfigVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 76);

/**
 * @generated from message codes.v3.PublishStudioConfigVersionResponse
 */
export type PublishStudioConfigVersionResponse = Message<"codes.v3.PublishStudioConfigVersionResponse"> & {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfig | undefined;
};

/**
 * @generated from message codes.v3.PublishStudioConfigVersionResponse
 */
export type PublishStudioConfigVersionResponseJson = {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfigJson;
};

/**
 * Describes the message codes.v3.PublishStudioConfigVersionResponse.
 * Use `create(PublishStudioConfigVersionResponseSchema)` to create a new message.
 */
export const PublishStudioConfigVersionResponseSchema: GenMessage<PublishStudioConfigVersionResponse, { jsonType: PublishStudioConfigVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 77);

/**
 * @generated from message codes.v3.UpdateStudioConfigRequest
 */
export type UpdateStudioConfigRequest = Message<"codes.v3.UpdateStudioConfigRequest"> & {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfig | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message codes.v3.UpdateStudioConfigRequest
 */
export type UpdateStudioConfigRequestJson = {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfigJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message codes.v3.UpdateStudioConfigRequest.
 * Use `create(UpdateStudioConfigRequestSchema)` to create a new message.
 */
export const UpdateStudioConfigRequestSchema: GenMessage<UpdateStudioConfigRequest, { jsonType: UpdateStudioConfigRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 78);

/**
 * @generated from message codes.v3.UpdateStudioConfigResponse
 */
export type UpdateStudioConfigResponse = Message<"codes.v3.UpdateStudioConfigResponse"> & {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfig | undefined;
};

/**
 * @generated from message codes.v3.UpdateStudioConfigResponse
 */
export type UpdateStudioConfigResponseJson = {
	/**
	 * @generated from field: codes.v3.StudioConfig studio_config = 1;
	 */
	studioConfig?: StudioConfigJson;
};

/**
 * Describes the message codes.v3.UpdateStudioConfigResponse.
 * Use `create(UpdateStudioConfigResponseSchema)` to create a new message.
 */
export const UpdateStudioConfigResponseSchema: GenMessage<UpdateStudioConfigResponse, { jsonType: UpdateStudioConfigResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 79);

/**
 * @generated from message codes.v3.DeleteStudioConfigRequest
 */
export type DeleteStudioConfigRequest = Message<"codes.v3.DeleteStudioConfigRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message codes.v3.DeleteStudioConfigRequest
 */
export type DeleteStudioConfigRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message codes.v3.DeleteStudioConfigRequest.
 * Use `create(DeleteStudioConfigRequestSchema)` to create a new message.
 */
export const DeleteStudioConfigRequestSchema: GenMessage<DeleteStudioConfigRequest, { jsonType: DeleteStudioConfigRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 80);

/**
 * @generated from message codes.v3.DeleteStudioConfigResponse
 */
export type DeleteStudioConfigResponse = Message<"codes.v3.DeleteStudioConfigResponse"> & {};

/**
 * @generated from message codes.v3.DeleteStudioConfigResponse
 */
export type DeleteStudioConfigResponseJson = {};

/**
 * Describes the message codes.v3.DeleteStudioConfigResponse.
 * Use `create(DeleteStudioConfigResponseSchema)` to create a new message.
 */
export const DeleteStudioConfigResponseSchema: GenMessage<DeleteStudioConfigResponse, { jsonType: DeleteStudioConfigResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 81);

/**
 * @generated from message codes.v3.ListStudioConfigsRequest
 */
export type ListStudioConfigsRequest = Message<"codes.v3.ListStudioConfigsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string | undefined;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId: string;

	/**
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags: string[];

	/**
	 * @generated from field: repeated string visibilities = 9;
	 */
	visibilities: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message codes.v3.ListStudioConfigsRequest
 */
export type ListStudioConfigsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId?: string;

	/**
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix?: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags?: string[];

	/**
	 * @generated from field: repeated string visibilities = 9;
	 */
	visibilities?: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message codes.v3.ListStudioConfigsRequest.
 * Use `create(ListStudioConfigsRequestSchema)` to create a new message.
 */
export const ListStudioConfigsRequestSchema: GenMessage<ListStudioConfigsRequest, { jsonType: ListStudioConfigsRequestJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 82);

/**
 * @generated from message codes.v3.ListStudioConfigsResponse
 */
export type ListStudioConfigsResponse = Message<"codes.v3.ListStudioConfigsResponse"> & {
	/**
	 * @generated from field: repeated codes.v3.StudioConfig studio_configs = 1;
	 */
	studioConfigs: StudioConfig[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message codes.v3.ListStudioConfigsResponse
 */
export type ListStudioConfigsResponseJson = {
	/**
	 * @generated from field: repeated codes.v3.StudioConfig studio_configs = 1;
	 */
	studioConfigs?: StudioConfigJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message codes.v3.ListStudioConfigsResponse.
 * Use `create(ListStudioConfigsResponseSchema)` to create a new message.
 */
export const ListStudioConfigsResponseSchema: GenMessage<ListStudioConfigsResponse, { jsonType: ListStudioConfigsResponseJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_codes, 83);

/**
 * @generated from enum codes.v3.DesignType
 */
export enum DesignType {
	/**
	 * @generated from enum value: DESIGN_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * code references a studio config asset
	 *
	 * @generated from enum value: DESIGN_TYPE_STUDIO_CONFIG = 1;
	 */
	STUDIO_CONFIG = 1,

	/**
	 * code has a raw embeded studio config
	 *
	 * @generated from enum value: DESIGN_TYPE_CUSTOM_CONFIG = 2;
	 */
	CUSTOM_CONFIG = 2,

	/**
	 * config generated from brandkit values
	 *
	 * @generated from enum value: DESIGN_TYPE_BRANDKIT_DERIVED = 3;
	 */
	BRANDKIT_DERIVED = 3,

	/**
	 * brandkit references a studio config asset
	 *
	 * @generated from enum value: DESIGN_TYPE_BRANDKIT_STUDIO_CONFIG = 4;
	 */
	BRANDKIT_STUDIO_CONFIG = 4,

	/**
	 * brandkit has a raw embeded studio config
	 *
	 * @generated from enum value: DESIGN_TYPE_BRANDKIT_CUSTOM_CONFIG = 5;
	 */
	BRANDKIT_CUSTOM_CONFIG = 5,
}

/**
 * @generated from enum codes.v3.DesignType
 */
export type DesignTypeJson = "DESIGN_TYPE_UNSPECIFIED" | "DESIGN_TYPE_STUDIO_CONFIG" | "DESIGN_TYPE_CUSTOM_CONFIG" | "DESIGN_TYPE_BRANDKIT_DERIVED" | "DESIGN_TYPE_BRANDKIT_STUDIO_CONFIG" | "DESIGN_TYPE_BRANDKIT_CUSTOM_CONFIG";

/**
 * Describes the enum codes.v3.DesignType.
 */
export const DesignTypeSchema: GenEnum<DesignType, DesignTypeJson> = /*@__PURE__*/ enumDesc(file_codes_v3_codes, 0);

/**
 * @generated from enum codes.v3.FileFormat
 */
export enum FileFormat {
	/**
	 * @generated from enum value: FILE_FORMAT_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: FILE_FORMAT_PNG = 1;
	 */
	PNG = 1,

	/**
	 * @generated from enum value: FILE_FORMAT_JPG = 2;
	 */
	JPG = 2,

	/**
	 * @generated from enum value: FILE_FORMAT_SVG = 3;
	 */
	SVG = 3,

	/**
	 * @generated from enum value: FILE_FORMAT_PDF = 4;
	 */
	PDF = 4,

	/**
	 * @generated from enum value: FILE_FORMAT_EPS = 5;
	 */
	EPS = 5,

	/**
	 * @generated from enum value: FILE_FORMAT_TIFF = 6;
	 */
	TIFF = 6,
}

/**
 * @generated from enum codes.v3.FileFormat
 */
export type FileFormatJson = "FILE_FORMAT_UNSPECIFIED" | "FILE_FORMAT_PNG" | "FILE_FORMAT_JPG" | "FILE_FORMAT_SVG" | "FILE_FORMAT_PDF" | "FILE_FORMAT_EPS" | "FILE_FORMAT_TIFF";

/**
 * Describes the enum codes.v3.FileFormat.
 */
export const FileFormatSchema: GenEnum<FileFormat, FileFormatJson> = /*@__PURE__*/ enumDesc(file_codes_v3_codes, 1);

/**
 *
 * Batch
 *
 * @generated from enum codes.v3.BatchType
 */
export enum BatchType {
	/**
	 * @generated from enum value: BATCH_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: BATCH_TYPE_GS1_DIGITAL_LINK = 1;
	 */
	GS1_DIGITAL_LINK = 1,
}

/**
 *
 * Batch
 *
 * @generated from enum codes.v3.BatchType
 */
export type BatchTypeJson = "BATCH_TYPE_UNSPECIFIED" | "BATCH_TYPE_GS1_DIGITAL_LINK";

/**
 * Describes the enum codes.v3.BatchType.
 */
export const BatchTypeSchema: GenEnum<BatchType, BatchTypeJson> = /*@__PURE__*/ enumDesc(file_codes_v3_codes, 2);

/**
 * @generated from service codes.v3.CodeService
 */
export const CodeService: GenService<{
	/**
	 * Codes
	 *
	 * @generated from rpc codes.v3.CodeService.CreateCode
	 */
	createCode: {
		methodKind: "unary";
		input: typeof CreateCodeRequestSchema;
		output: typeof CreateCodeResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.ListCodes
	 */
	listCodes: {
		methodKind: "unary";
		input: typeof ListCodesRequestSchema;
		output: typeof ListCodesResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.GetCode
	 */
	getCode: {
		methodKind: "unary";
		input: typeof GetCodeRequestSchema;
		output: typeof GetCodeResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.GetCodeInBatch
	 */
	getCodeInBatch: {
		methodKind: "unary";
		input: typeof GetCodeInBatchRequestSchema;
		output: typeof GetCodeInBatchResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.GetCodes
	 */
	getCodes: {
		methodKind: "unary";
		input: typeof GetCodesRequestSchema;
		output: typeof GetCodesResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.UpdateCode
	 */
	updateCode: {
		methodKind: "unary";
		input: typeof UpdateCodeRequestSchema;
		output: typeof UpdateCodeResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.DeleteCode
	 */
	deleteCode: {
		methodKind: "unary";
		input: typeof DeleteCodeRequestSchema;
		output: typeof DeleteCodeResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.AddCodeToBatch
	 */
	addCodeToBatch: {
		methodKind: "unary";
		input: typeof AddCodeToBatchRequestSchema;
		output: typeof AddCodeToBatchResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.UpsertCodesInBatch
	 */
	upsertCodesInBatch: {
		methodKind: "unary";
		input: typeof UpsertCodesInBatchRequestSchema;
		output: typeof UpsertCodesInBatchResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.AddCodesToBatch
	 */
	addCodesToBatch: {
		methodKind: "unary";
		input: typeof AddCodesToBatchRequestSchema;
		output: typeof AddCodesToBatchResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.UpdateCodesInBatch
	 */
	updateCodesInBatch: {
		methodKind: "unary";
		input: typeof UpdateCodesInBatchRequestSchema;
		output: typeof UpdateCodesInBatchResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.ExportCode
	 */
	exportCode: {
		methodKind: "unary";
		input: typeof ExportCodeRequestSchema;
		output: typeof ExportCodeResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.BulkExportCodes
	 */
	bulkExportCodes: {
		methodKind: "unary";
		input: typeof BulkExportCodesRequestSchema;
		output: typeof BulkExportCodesResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.ExportCodeMasks
	 */
	exportCodeMasks: {
		methodKind: "unary";
		input: typeof ExportCodeMasksRequestSchema;
		output: typeof ExportCodeMasksResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.BulkImportCodes
	 */
	bulkImportCodes: {
		methodKind: "unary";
		input: typeof BulkImportCodesRequestSchema;
		output: typeof BulkImportCodesResponseSchema;
	};
	/**
	 * Studio Configs
	 *
	 * @generated from rpc codes.v3.CodeService.CreateStudioConfig
	 */
	createStudioConfig: {
		methodKind: "unary";
		input: typeof CreateStudioConfigRequestSchema;
		output: typeof CreateStudioConfigResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.CreateStudioConfigVersion
	 */
	createStudioConfigVersion: {
		methodKind: "unary";
		input: typeof CreateStudioConfigVersionRequestSchema;
		output: typeof CreateStudioConfigVersionResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.PublishStudioConfigVersion
	 */
	publishStudioConfigVersion: {
		methodKind: "unary";
		input: typeof PublishStudioConfigVersionRequestSchema;
		output: typeof PublishStudioConfigVersionResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.ListStudioConfigs
	 */
	listStudioConfigs: {
		methodKind: "unary";
		input: typeof ListStudioConfigsRequestSchema;
		output: typeof ListStudioConfigsResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.GetStudioConfig
	 */
	getStudioConfig: {
		methodKind: "unary";
		input: typeof GetStudioConfigRequestSchema;
		output: typeof GetStudioConfigResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.UpdateStudioConfig
	 */
	updateStudioConfig: {
		methodKind: "unary";
		input: typeof UpdateStudioConfigRequestSchema;
		output: typeof UpdateStudioConfigResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.DeleteStudioConfig
	 */
	deleteStudioConfig: {
		methodKind: "unary";
		input: typeof DeleteStudioConfigRequestSchema;
		output: typeof DeleteStudioConfigResponseSchema;
	};
	/**
	 * Batches
	 *
	 * @generated from rpc codes.v3.CodeService.CreateBatch
	 */
	createBatch: {
		methodKind: "unary";
		input: typeof CreateBatchRequestSchema;
		output: typeof CreateBatchResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.CreateBatchFromTemplate
	 */
	createBatchFromTemplate: {
		methodKind: "unary";
		input: typeof CreateBatchFromTemplateRequestSchema;
		output: typeof CreateBatchFromTemplateResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.ListBatches
	 */
	listBatches: {
		methodKind: "unary";
		input: typeof ListBatchesRequestSchema;
		output: typeof ListBatchesResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.GetBatch
	 */
	getBatch: {
		methodKind: "unary";
		input: typeof GetBatchRequestSchema;
		output: typeof GetBatchResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.UpdateBatch
	 */
	updateBatch: {
		methodKind: "unary";
		input: typeof UpdateBatchRequestSchema;
		output: typeof UpdateBatchResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.DeleteBatch
	 */
	deleteBatch: {
		methodKind: "unary";
		input: typeof DeleteBatchRequestSchema;
		output: typeof DeleteBatchResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.DeleteCodesInBatch
	 */
	deleteCodesInBatch: {
		methodKind: "unary";
		input: typeof DeleteCodesInBatchRequestSchema;
		output: typeof DeleteCodesInBatchResponseSchema;
	};
	/**
	 * Batch templates
	 *
	 * @generated from rpc codes.v3.CodeService.CreateBatchTemplate
	 */
	createBatchTemplate: {
		methodKind: "unary";
		input: typeof CreateBatchTemplateRequestSchema;
		output: typeof CreateBatchTemplateResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.CreateBatchTemplateVersion
	 */
	createBatchTemplateVersion: {
		methodKind: "unary";
		input: typeof CreateBatchTemplateVersionRequestSchema;
		output: typeof CreateBatchTemplateVersionResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.PublishBatchTemplateVersion
	 */
	publishBatchTemplateVersion: {
		methodKind: "unary";
		input: typeof PublishBatchTemplateVersionRequestSchema;
		output: typeof PublishBatchTemplateVersionResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.ListBatchTemplates
	 */
	listBatchTemplates: {
		methodKind: "unary";
		input: typeof ListBatchTemplatesRequestSchema;
		output: typeof ListBatchTemplatesResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.GetBatchTemplate
	 */
	getBatchTemplate: {
		methodKind: "unary";
		input: typeof GetBatchTemplateRequestSchema;
		output: typeof GetBatchTemplateResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.UpdateBatchTemplate
	 */
	updateBatchTemplate: {
		methodKind: "unary";
		input: typeof UpdateBatchTemplateRequestSchema;
		output: typeof UpdateBatchTemplateResponseSchema;
	};
	/**
	 * @generated from rpc codes.v3.CodeService.DeleteBatchTemplate
	 */
	deleteBatchTemplate: {
		methodKind: "unary";
		input: typeof DeleteBatchTemplateRequestSchema;
		output: typeof DeleteBatchTemplateResponseSchema;
	};
	/**
	 * design utils
	 *
	 * @generated from rpc codes.v3.CodeService.PreviewDesign
	 */
	previewDesign: {
		methodKind: "unary";
		input: typeof PreviewDesignRequestSchema;
		output: typeof PreviewDesignResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_codes_v3_codes, 0);
